/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as msRest from "@azure/ms-rest-js";
import * as Models from "./models";
import * as Mappers from "./models/mappers";
import * as Parameters from "./models/parameters";
import { ApiContext } from "./apiContext";
var Api = /** @class */ (function (_super) {
    __extends(Api, _super);
    /**
     * Initializes a new instance of the Api class.
     * @param [options] The parameter options
     */
    function Api(options) {
        return _super.call(this, options) || this;
    }
    Api.prototype.createCustomerAcceptedTerm = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, createCustomerAcceptedTermOperationSpec, callback);
    };
    Api.prototype.updateAccountsMyChangePassword = function (loginString, options, callback) {
        return this.sendOperationRequest({
            loginString: loginString,
            options: options
        }, updateAccountsMyChangePasswordOperationSpec, callback);
    };
    Api.prototype.getAccountsMy = function (loginString, options, callback) {
        return this.sendOperationRequest({
            loginString: loginString,
            options: options
        }, getAccountsMyOperationSpec, callback);
    };
    Api.prototype.createAccountsMySendTemporaryPassword = function (loginString, options, callback) {
        return this.sendOperationRequest({
            loginString: loginString,
            options: options
        }, createAccountsMySendTemporaryPasswordOperationSpec, callback);
    };
    Api.prototype.updateAccountsMyResetPassword = function (loginString, options, callback) {
        return this.sendOperationRequest({
            loginString: loginString,
            options: options
        }, updateAccountsMyResetPasswordOperationSpec, callback);
    };
    Api.prototype.getAccountsChangePasswordMetadata = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getAccountsChangePasswordMetadataOperationSpec, callback);
    };
    Api.prototype.getAccountsMyPermissions = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getAccountsMyPermissionsOperationSpec, callback);
    };
    Api.prototype.getCustomerAddresses = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerAddressesOperationSpec, callback);
    };
    Api.prototype.createCustomerAddress = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, createCustomerAddressOperationSpec, callback);
    };
    Api.prototype.updateCustomerAddress = function (customerId, addressId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            addressId: addressId,
            options: options
        }, updateCustomerAddressOperationSpec, callback);
    };
    Api.prototype.deleteCustomerAddress = function (customerId, addressId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            addressId: addressId,
            options: options
        }, deleteCustomerAddressOperationSpec, callback);
    };
    Api.prototype.getCustomerAddressesMetadata = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerAddressesMetadataOperationSpec, callback);
    };
    Api.prototype.getAddressFormats = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getAddressFormatsOperationSpec, callback);
    };
    Api.prototype.getAddressFormat = function (type, options, callback) {
        return this.sendOperationRequest({
            type: type,
            options: options
        }, getAddressFormatOperationSpec, callback);
    };
    Api.prototype.getCustomerApproval = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerApprovalOperationSpec, callback);
    };
    Api.prototype.updateCustomerApproval = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, updateCustomerApprovalOperationSpec, callback);
    };
    Api.prototype.getCustomerApprovalMetadata = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerApprovalMetadataOperationSpec, callback);
    };
    Api.prototype.getAtpClusterAtp = function (atpClusterId, itemCode, options, callback) {
        return this.sendOperationRequest({
            atpClusterId: atpClusterId,
            itemCode: itemCode,
            options: options
        }, getAtpClusterAtpOperationSpec, callback);
    };
    Api.prototype.getAtpClusterAtps = function (atpClusterId, options, callback) {
        return this.sendOperationRequest({
            atpClusterId: atpClusterId,
            options: options
        }, getAtpClusterAtpsOperationSpec, callback);
    };
    Api.prototype.getAtpCluster = function (atpClusterId, options, callback) {
        return this.sendOperationRequest({
            atpClusterId: atpClusterId,
            options: options
        }, getAtpClusterOperationSpec, callback);
    };
    Api.prototype.getAtpClusters = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getAtpClustersOperationSpec, callback);
    };
    Api.prototype.getCustomerAutoshipConfiguration = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerAutoshipConfigurationOperationSpec, callback);
    };
    Api.prototype.getCustomerAutoshipAvailabilities = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerAutoshipAvailabilitiesOperationSpec, callback);
    };
    Api.prototype.getCustomerAutoshipTypes = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerAutoshipTypesOperationSpec, callback);
    };
    Api.prototype.getCustomerAutoshipLegalArticles = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerAutoshipLegalArticlesOperationSpec, callback);
    };
    Api.prototype.createCustomerAutoshipInstruction = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, createCustomerAutoshipInstructionOperationSpec, callback);
    };
    Api.prototype.getConceptAvailability = function (conceptCode, options, callback) {
        return this.sendOperationRequest({
            conceptCode: conceptCode,
            options: options
        }, getConceptAvailabilityOperationSpec, callback);
    };
    Api.prototype.getCustomerConceptsAvailabilities = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerConceptsAvailabilitiesOperationSpec, callback);
    };
    Api.prototype.getConceptsAvailabilities = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getConceptsAvailabilitiesOperationSpec, callback);
    };
    Api.prototype.getCustomerConceptAvailability = function (customerId, conceptCode, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            conceptCode: conceptCode,
            options: options
        }, getCustomerConceptAvailabilityOperationSpec, callback);
    };
    Api.prototype.getCustomerProductAvailability = function (customerId, productCode, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            productCode: productCode,
            options: options
        }, getCustomerProductAvailabilityOperationSpec, callback);
    };
    Api.prototype.getProductAvailability = function (productCode, options, callback) {
        return this.sendOperationRequest({
            productCode: productCode,
            options: options
        }, getProductAvailabilityOperationSpec, callback);
    };
    Api.prototype.getProductsAvailability = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getProductsAvailabilityOperationSpec, callback);
    };
    Api.prototype.getCustomerProductsAvailability = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerProductsAvailabilityOperationSpec, callback);
    };
    Api.prototype.getBackInStockNotifications = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getBackInStockNotificationsOperationSpec, callback);
    };
    Api.prototype.createBackInStockNotificationSubscription = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, createBackInStockNotificationSubscriptionOperationSpec, callback);
    };
    Api.prototype.getBackInStockNotificationsConfiguration = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getBackInStockNotificationsConfigurationOperationSpec, callback);
    };
    Api.prototype.getCustomerBackInStockNotifications = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerBackInStockNotificationsOperationSpec, callback);
    };
    Api.prototype.createCustomerBackInStockNotificationSubscription = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, createCustomerBackInStockNotificationSubscriptionOperationSpec, callback);
    };
    Api.prototype.getCustomerBankAccounts = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerBankAccountsOperationSpec, callback);
    };
    Api.prototype.createCustomerBankAccount = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, createCustomerBankAccountOperationSpec, callback);
    };
    Api.prototype.updateCustomerBankAccount = function (customerId, bankAccountId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            bankAccountId: bankAccountId,
            options: options
        }, updateCustomerBankAccountOperationSpec, callback);
    };
    Api.prototype.deleteCustomerBankAccount = function (customerId, bankAccountId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            bankAccountId: bankAccountId,
            options: options
        }, deleteCustomerBankAccountOperationSpec, callback);
    };
    Api.prototype.getCustomerBankAccountsMetadata = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerBankAccountsMetadataOperationSpec, callback);
    };
    Api.prototype.getBankBranches = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getBankBranchesOperationSpec, callback);
    };
    Api.prototype.getBankBranch = function (bankBranchId, options, callback) {
        return this.sendOperationRequest({
            bankBranchId: bankBranchId,
            options: options
        }, getBankBranchOperationSpec, callback);
    };
    Api.prototype.getBanks = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getBanksOperationSpec, callback);
    };
    Api.prototype.getBank = function (bankId, options, callback) {
        return this.sendOperationRequest({
            bankId: bankId,
            options: options
        }, getBankOperationSpec, callback);
    };
    Api.prototype.updateShoppingSessionBasketOffer = function (sessionId, offerId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            offerId: offerId,
            options: options
        }, updateShoppingSessionBasketOfferOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionBasketOffers = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, getShoppingSessionBasketOffersOperationSpec, callback);
    };
    Api.prototype.getBlockingCodes = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getBlockingCodesOperationSpec, callback);
    };
    Api.prototype.getCustomerBlockings = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerBlockingsOperationSpec, callback);
    };
    Api.prototype.getBrands = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getBrandsOperationSpec, callback);
    };
    Api.prototype.createCallInteraction = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, createCallInteractionOperationSpec, callback);
    };
    Api.prototype.getCampaignPoints = function (campaignId, options, callback) {
        return this.sendOperationRequest({
            campaignId: campaignId,
            options: options
        }, getCampaignPointsOperationSpec, callback);
    };
    Api.prototype.getCampaigns = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getCampaignsOperationSpec, callback);
    };
    Api.prototype.getCampaignsWelcomeProgramTargets = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getCampaignsWelcomeProgramTargetsOperationSpec, callback);
    };
    Api.prototype.getCampaignsActivityProgramTargets = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getCampaignsActivityProgramTargetsOperationSpec, callback);
    };
    Api.prototype.getCustomerCampaignBenefits = function (customerId, campaignType, productCodes, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            campaignType: campaignType,
            productCodes: productCodes,
            options: options
        }, getCustomerCampaignBenefitsOperationSpec, callback);
    };
    Api.prototype.getCataloguesCatalogueContent = function (catalogueCode, catalogueCode1, options, callback) {
        return this.sendOperationRequest({
            catalogueCode: catalogueCode,
            catalogueCode1: catalogueCode1,
            options: options
        }, getCataloguesCatalogueContentOperationSpec, callback);
    };
    Api.prototype.getCatalogueCatalogueItem = function (catalogueId, catalogueItemId, options, callback) {
        return this.sendOperationRequest({
            catalogueId: catalogueId,
            catalogueItemId: catalogueItemId,
            options: options
        }, getCatalogueCatalogueItemOperationSpec, callback);
    };
    Api.prototype.getCatalogueCatalogueItems = function (catalogueId, options, callback) {
        return this.sendOperationRequest({
            catalogueId: catalogueId,
            options: options
        }, getCatalogueCatalogueItemsOperationSpec, callback);
    };
    Api.prototype.getCatalogues = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getCataloguesOperationSpec, callback);
    };
    Api.prototype.getSocialMediaLibraryCategory = function (categoryId, options, callback) {
        return this.sendOperationRequest({
            categoryId: categoryId,
            options: options
        }, getSocialMediaLibraryCategoryOperationSpec, callback);
    };
    Api.prototype.getSocialMediaLibraryCategories = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getSocialMediaLibraryCategoriesOperationSpec, callback);
    };
    Api.prototype.getCategories = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getCategoriesOperationSpec, callback);
    };
    Api.prototype.getConceptLabels = function (conceptCodes, options, callback) {
        return this.sendOperationRequest({
            conceptCodes: conceptCodes,
            options: options
        }, getConceptLabelsOperationSpec, callback);
    };
    Api.prototype.getConcepts = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getConceptsOperationSpec, callback);
    };
    Api.prototype.getConcept = function (conceptCode, options, callback) {
        return this.sendOperationRequest({
            conceptCode: conceptCode,
            options: options
        }, getConceptOperationSpec, callback);
    };
    Api.prototype.getApplicationsSocialMediaLibraryConfiguration = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getApplicationsSocialMediaLibraryConfigurationOperationSpec, callback);
    };
    Api.prototype.getApplicationsSocialMediaLibraryLocalization = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getApplicationsSocialMediaLibraryLocalizationOperationSpec, callback);
    };
    Api.prototype.createCustomerConfirmation = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, createCustomerConfirmationOperationSpec, callback);
    };
    Api.prototype.getLoginProvidersWeChatExternalAccountConnectedUser = function (unionId, options, callback) {
        return this.sendOperationRequest({
            unionId: unionId,
            options: options
        }, getLoginProvidersWeChatExternalAccountConnectedUserOperationSpec, callback);
    };
    Api.prototype.getConsultantTitles = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getConsultantTitlesOperationSpec, callback);
    };
    Api.prototype.getConsultantCustomerId = function (consultantNumber, options, callback) {
        return this.sendOperationRequest({
            consultantNumber: consultantNumber,
            options: options
        }, getConsultantCustomerIdOperationSpec, callback);
    };
    Api.prototype.getCustomerConsultantNumber = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerConsultantNumberOperationSpec, callback);
    };
    Api.prototype.getCustomerConsultantNumberDeprecated = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerConsultantNumberDeprecatedOperationSpec, callback);
    };
    Api.prototype.getConsultantCustomerIdDeprecated = function (consultantNumber, options, callback) {
        return this.sendOperationRequest({
            consultantNumber: consultantNumber,
            options: options
        }, getConsultantCustomerIdDeprecatedOperationSpec, callback);
    };
    Api.prototype.getCustomerCustomerAttributeDeprecated = function (customerId, customerAttributeTypeId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            customerAttributeTypeId: customerAttributeTypeId,
            options: options
        }, getCustomerCustomerAttributeDeprecatedOperationSpec, callback);
    };
    Api.prototype.updateCustomerCustomerAttributeDeprecated = function (customerId, customerAttributeTypeId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            customerAttributeTypeId: customerAttributeTypeId,
            options: options
        }, updateCustomerCustomerAttributeDeprecatedOperationSpec, callback);
    };
    Api.prototype.getCustomerCustomerAttributesDeprecated = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerCustomerAttributesDeprecatedOperationSpec, callback);
    };
    Api.prototype.getCustomerAttributesIdentityCardDeprecated = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerAttributesIdentityCardDeprecatedOperationSpec, callback);
    };
    Api.prototype.updateCustomerAttributesIdentityCardDeprecated = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, updateCustomerAttributesIdentityCardDeprecatedOperationSpec, callback);
    };
    Api.prototype.getCustomerAttributesEInvoiceApprovalDeprecated = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerAttributesEInvoiceApprovalDeprecatedOperationSpec, callback);
    };
    Api.prototype.updateCustomerAttributesEInvoiceApprovalDeprecated = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, updateCustomerAttributesEInvoiceApprovalDeprecatedOperationSpec, callback);
    };
    Api.prototype.getCustomerAttributesMetadataDeprecated = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerAttributesMetadataDeprecatedOperationSpec, callback);
    };
    Api.prototype.getCustomerIdentityCard = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerIdentityCardOperationSpec, callback);
    };
    Api.prototype.updateCustomerIdentityCard = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, updateCustomerIdentityCardOperationSpec, callback);
    };
    Api.prototype.getCustomerEInvoiceApproval = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerEInvoiceApprovalOperationSpec, callback);
    };
    Api.prototype.updateCustomerEInvoiceApproval = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, updateCustomerEInvoiceApprovalOperationSpec, callback);
    };
    Api.prototype.getCustomerMetadata = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerMetadataOperationSpec, callback);
    };
    Api.prototype.getCustomerConceptLabels = function (customerId, conceptCodes, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            conceptCodes: conceptCodes,
            options: options
        }, getCustomerConceptLabelsOperationSpec, callback);
    };
    Api.prototype.getCustomerWelcomeProgram = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerWelcomeProgramOperationSpec, callback);
    };
    Api.prototype.getCustomerActivityProgram = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerActivityProgramOperationSpec, callback);
    };
    Api.prototype.getCustomerRecruitmentCampaign = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerRecruitmentCampaignOperationSpec, callback);
    };
    Api.prototype.getCustomerPersonalSales = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerPersonalSalesOperationSpec, callback);
    };
    Api.prototype.getCustomerPersonalSalesHistory = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerPersonalSalesHistoryOperationSpec, callback);
    };
    Api.prototype.getCustomerLoyaltyProgram = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerLoyaltyProgramOperationSpec, callback);
    };
    Api.prototype.getCustomerProductsLabels = function (customerId, productCodes, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            productCodes: productCodes,
            options: options
        }, getCustomerProductsLabelsOperationSpec, callback);
    };
    Api.prototype.createReportsCustomerStatus = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, createReportsCustomerStatusOperationSpec, callback);
    };
    Api.prototype.getCustomerLocalConsultantTitle = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerLocalConsultantTitleOperationSpec, callback);
    };
    Api.prototype.getCustomerDeliveryAddress = function (customerId, deliveryAddressId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            deliveryAddressId: deliveryAddressId,
            options: options
        }, getCustomerDeliveryAddressOperationSpec, callback);
    };
    Api.prototype.getDeliveryChannel = function (deliveryChannelId, options, callback) {
        return this.sendOperationRequest({
            deliveryChannelId: deliveryChannelId,
            options: options
        }, getDeliveryChannelOperationSpec, callback);
    };
    Api.prototype.getDeliveryChannelAddress = function (deliveryChannelId, options, callback) {
        return this.sendOperationRequest({
            deliveryChannelId: deliveryChannelId,
            options: options
        }, getDeliveryChannelAddressOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionDeliveryChannels = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, getShoppingSessionDeliveryChannelsOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionDeliveryChannel = function (sessionId, deliveryChannelId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            deliveryChannelId: deliveryChannelId,
            options: options
        }, getShoppingSessionDeliveryChannelOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionDeliveryMethods = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, getShoppingSessionDeliveryMethodsOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionDelivery = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, getShoppingSessionDeliveryOperationSpec, callback);
    };
    Api.prototype.updateShoppingSessionDelivery = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, updateShoppingSessionDeliveryOperationSpec, callback);
    };
    Api.prototype.createCourierWayBillNumberDeliveryStatus = function (courierId, wayBillNumber, options, callback) {
        return this.sendOperationRequest({
            courierId: courierId,
            wayBillNumber: wayBillNumber,
            options: options
        }, createCourierWayBillNumberDeliveryStatusOperationSpec, callback);
    };
    Api.prototype.createCustomerDocument = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, createCustomerDocumentOperationSpec, callback);
    };
    Api.prototype.getCustomerDocumentImage = function (customerId, documentId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            documentId: documentId,
            options: options
        }, getCustomerDocumentImageOperationSpec, callback);
    };
    Api.prototype.getCustomerDocument = function (customerId, documentId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            documentId: documentId,
            options: options
        }, getCustomerDocumentOperationSpec, callback);
    };
    Api.prototype.deleteCustomerDocument = function (customerId, documentId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            documentId: documentId,
            options: options
        }, deleteCustomerDocumentOperationSpec, callback);
    };
    Api.prototype.getCustomerDocumentsInfos = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerDocumentsInfosOperationSpec, callback);
    };
    Api.prototype.getDocumentTypes = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getDocumentTypesOperationSpec, callback);
    };
    Api.prototype.createDocument = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, createDocumentOperationSpec, callback);
    };
    Api.prototype.getDocumentImage = function (documentId, options, callback) {
        return this.sendOperationRequest({
            documentId: documentId,
            options: options
        }, getDocumentImageOperationSpec, callback);
    };
    Api.prototype.getDocument = function (documentId, options, callback) {
        return this.sendOperationRequest({
            documentId: documentId,
            options: options
        }, getDocumentOperationSpec, callback);
    };
    Api.prototype.getDocumentsInfos = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getDocumentsInfosOperationSpec, callback);
    };
    Api.prototype.getCustomerDocumentApprovalDeprecated = function (customerId, documentId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            documentId: documentId,
            options: options
        }, getCustomerDocumentApprovalDeprecatedOperationSpec, callback);
    };
    Api.prototype.getCustomerDocumentsApprovalsDeprecated = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerDocumentsApprovalsDeprecatedOperationSpec, callback);
    };
    Api.prototype.getCustomerDocumentApprovals = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerDocumentApprovalsOperationSpec, callback);
    };
    Api.prototype.createCustomerDocumentApproval = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, createCustomerDocumentApprovalOperationSpec, callback);
    };
    Api.prototype.getCustomerDocumentApproval = function (customerId, documentApprovalId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            documentApprovalId: documentApprovalId,
            options: options
        }, getCustomerDocumentApprovalOperationSpec, callback);
    };
    Api.prototype.getCustomerDownlinePerformance = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerDownlinePerformanceOperationSpec, callback);
    };
    Api.prototype.getCustomerEmails = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerEmailsOperationSpec, callback);
    };
    Api.prototype.createCustomerEmail = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, createCustomerEmailOperationSpec, callback);
    };
    Api.prototype.deleteCustomerEmail = function (customerId, emailAddress, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            emailAddress: emailAddress,
            options: options
        }, deleteCustomerEmailOperationSpec, callback);
    };
    Api.prototype.getCustomerEmailsMetadata = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerEmailsMetadataOperationSpec, callback);
    };
    Api.prototype.createEndConsumerOrder = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, createEndConsumerOrderOperationSpec, callback);
    };
    Api.prototype.getEndConsumerOrders = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getEndConsumerOrdersOperationSpec, callback);
    };
    Api.prototype.getCustomerEndConsumers = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerEndConsumersOperationSpec, callback);
    };
    Api.prototype.createCustomerEndConsumer = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, createCustomerEndConsumerOperationSpec, callback);
    };
    Api.prototype.getCustomerEndConsumer = function (customerId, endConsumerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            endConsumerId: endConsumerId,
            options: options
        }, getCustomerEndConsumerOperationSpec, callback);
    };
    Api.prototype.updateCustomerEndConsumer = function (customerId, endConsumerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            endConsumerId: endConsumerId,
            options: options
        }, updateCustomerEndConsumerOperationSpec, callback);
    };
    Api.prototype.deleteCustomerEndConsumer = function (customerId, endConsumerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            endConsumerId: endConsumerId,
            options: options
        }, deleteCustomerEndConsumerOperationSpec, callback);
    };
    Api.prototype.getEndConsumersMetadata = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getEndConsumersMetadataOperationSpec, callback);
    };
    Api.prototype.getApplicationsEndCustomerReferralDiscountLocalization = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getApplicationsEndCustomerReferralDiscountLocalizationOperationSpec, callback);
    };
    Api.prototype.createCustomersEndCustomer = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, createCustomersEndCustomerOperationSpec, callback);
    };
    Api.prototype.getCustomersEndCustomerMetadata = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getCustomersEndCustomerMetadataOperationSpec, callback);
    };
    Api.prototype.getSystemEndpointsIdentityServer = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getSystemEndpointsIdentityServerOperationSpec, callback);
    };
    Api.prototype.getSystemEndpointsOnline = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getSystemEndpointsOnlineOperationSpec, callback);
    };
    Api.prototype.getCustomerExternalAccountsWeChatUnionId = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerExternalAccountsWeChatUnionIdOperationSpec, callback);
    };
    Api.prototype.getCustomerExternalProfiles = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerExternalProfilesOperationSpec, callback);
    };
    Api.prototype.deleteCustomerExternalAccount = function (customerId, externalProvider, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            externalProvider: externalProvider,
            options: options
        }, deleteCustomerExternalAccountOperationSpec, callback);
    };
    Api.prototype.createCustomerSocialEntityTypeSocialEntityFavorite = function (customerId, socialEntityType, socialEntityId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            socialEntityType: socialEntityType,
            socialEntityId: socialEntityId,
            options: options
        }, createCustomerSocialEntityTypeSocialEntityFavoriteOperationSpec, callback);
    };
    Api.prototype.deleteCustomerSocialEntityTypeSocialEntityFavorite = function (customerId, socialEntityType, socialEntityId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            socialEntityType: socialEntityType,
            socialEntityId: socialEntityId,
            options: options
        }, deleteCustomerSocialEntityTypeSocialEntityFavoriteOperationSpec, callback);
    };
    Api.prototype.getCustomerFinancialSet = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerFinancialSetOperationSpec, callback);
    };
    Api.prototype.getApplicationsOriflameAppFrontPageBanners = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getApplicationsOriflameAppFrontPageBannersOperationSpec, callback);
    };
    Api.prototype.getApplicationsOriflameAppFrontPageBanner = function (frontPageBannerId, options, callback) {
        return this.sendOperationRequest({
            frontPageBannerId: frontPageBannerId,
            options: options
        }, getApplicationsOriflameAppFrontPageBannerOperationSpec, callback);
    };
    Api.prototype.getCustomerGrantedCredit = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerGrantedCreditOperationSpec, callback);
    };
    Api.prototype.updateCustomerGrantedCredit = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, updateCustomerGrantedCreditOperationSpec, callback);
    };
    Api.prototype.getCustomerGuaranteeCredit = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerGuaranteeCreditOperationSpec, callback);
    };
    Api.prototype.getApplicationsGuaranteeCreditLocalization = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getApplicationsGuaranteeCreditLocalizationOperationSpec, callback);
    };
    Api.prototype.getApplicationsGuaranteeCreditGrantedCreditConfiguration = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getApplicationsGuaranteeCreditGrantedCreditConfigurationOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionHomeDeliveryOptions = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, getShoppingSessionHomeDeliveryOptionsOperationSpec, callback);
    };
    Api.prototype.getSocialMediaLibraryImageInfo = function (imageInfoId, options, callback) {
        return this.sendOperationRequest({
            imageInfoId: imageInfoId,
            options: options
        }, getSocialMediaLibraryImageInfoOperationSpec, callback);
    };
    Api.prototype.getSocialMediaLibraryImageInfos = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getSocialMediaLibraryImageInfosOperationSpec, callback);
    };
    Api.prototype.getInAppNotifications = function (xTenantContext, xClientApplication, acceptLanguage, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            xClientApplication: xClientApplication,
            acceptLanguage: acceptLanguage,
            options: options
        }, getInAppNotificationsOperationSpec, callback);
    };
    Api.prototype.getInAppNotificationUpdates = function (xTenantContext, xClientApplication, acceptLanguage, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            xClientApplication: xClientApplication,
            acceptLanguage: acceptLanguage,
            options: options
        }, getInAppNotificationUpdatesOperationSpec, callback);
    };
    Api.prototype.getCustomerInAppNotifications = function (xTenantContext, xClientApplication, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            xClientApplication: xClientApplication,
            customerId: customerId,
            options: options
        }, getCustomerInAppNotificationsOperationSpec, callback);
    };
    Api.prototype.deleteCustomerInAppNotifications = function (xTenantContext, customerId, xClientApplication, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            xClientApplication: xClientApplication,
            options: options
        }, deleteCustomerInAppNotificationsOperationSpec, callback);
    };
    Api.prototype.getCustomerInAppNotificationUpdates = function (xTenantContext, xClientApplication, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            xClientApplication: xClientApplication,
            customerId: customerId,
            options: options
        }, getCustomerInAppNotificationUpdatesOperationSpec, callback);
    };
    Api.prototype.createCustomerInAppNotificationViewed = function (xTenantContext, notificationId, customerId, xClientApplication, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            notificationId: notificationId,
            customerId: customerId,
            xClientApplication: xClientApplication,
            options: options
        }, createCustomerInAppNotificationViewedOperationSpec, callback);
    };
    Api.prototype.createCustomerInAppNotificationsViewed = function (xTenantContext, customerId, xClientApplication, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            customerId: customerId,
            xClientApplication: xClientApplication,
            options: options
        }, createCustomerInAppNotificationsViewedOperationSpec, callback);
    };
    Api.prototype.deleteCustomerInAppNotification = function (xTenantContext, notificationId, customerId, xClientApplication, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            notificationId: notificationId,
            customerId: customerId,
            xClientApplication: xClientApplication,
            options: options
        }, deleteCustomerInAppNotificationOperationSpec, callback);
    };
    Api.prototype.getNotificationMessageTypes = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getNotificationMessageTypesOperationSpec, callback);
    };
    Api.prototype.getIngredients = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getIngredientsOperationSpec, callback);
    };
    Api.prototype.getIngredient = function (ingredientCode, options, callback) {
        return this.sendOperationRequest({
            ingredientCode: ingredientCode,
            options: options
        }, getIngredientOperationSpec, callback);
    };
    Api.prototype.getJoiningFeeDialogHtml = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getJoiningFeeDialogHtmlOperationSpec, callback);
    };
    Api.prototype.createCustomerSocialEntityTypeSocialEntityLike = function (customerId, socialEntityType, socialEntityId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            socialEntityType: socialEntityType,
            socialEntityId: socialEntityId,
            options: options
        }, createCustomerSocialEntityTypeSocialEntityLikeOperationSpec, callback);
    };
    Api.prototype.deleteCustomerSocialEntityTypeSocialEntityLike = function (customerId, socialEntityType, socialEntityId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            socialEntityType: socialEntityType,
            socialEntityId: socialEntityId,
            options: options
        }, deleteCustomerSocialEntityTypeSocialEntityLikeOperationSpec, callback);
    };
    Api.prototype.getAddressNodes = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getAddressNodesOperationSpec, callback);
    };
    Api.prototype.getAddressNode = function (nodeId, options, callback) {
        return this.sendOperationRequest({
            nodeId: nodeId,
            options: options
        }, getAddressNodeOperationSpec, callback);
    };
    Api.prototype.getAddressSuggestions = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getAddressSuggestionsOperationSpec, callback);
    };
    Api.prototype.getApplicationsMakeupwizardLooks = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getApplicationsMakeupwizardLooksOperationSpec, callback);
    };
    Api.prototype.getApplicationsMakeupwizardLooktags = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getApplicationsMakeupwizardLooktagsOperationSpec, callback);
    };
    Api.prototype.getApplicationsMakeupwizardLocalization = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getApplicationsMakeupwizardLocalizationOperationSpec, callback);
    };
    Api.prototype.getApplicationsMakeupwizardCategories = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getApplicationsMakeupwizardCategoriesOperationSpec, callback);
    };
    Api.prototype.getApplicationsMakeupwizardWelcomeScreenSteps = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getApplicationsMakeupwizardWelcomeScreenStepsOperationSpec, callback);
    };
    Api.prototype.getCommissionPlansMatureMarketTitleQualifications = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getCommissionPlansMatureMarketTitleQualificationsOperationSpec, callback);
    };
    Api.prototype.getCustomerNameBankContacts = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerNameBankContactsOperationSpec, callback);
    };
    Api.prototype.createCustomerNameBankContact = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, createCustomerNameBankContactOperationSpec, callback);
    };
    Api.prototype.getCustomerNameBankContact = function (customerId, contactId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            contactId: contactId,
            options: options
        }, getCustomerNameBankContactOperationSpec, callback);
    };
    Api.prototype.updateCustomerNameBankContact = function (customerId, contactId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            contactId: contactId,
            options: options
        }, updateCustomerNameBankContactOperationSpec, callback);
    };
    Api.prototype.deleteCustomerNameBankContact = function (customerId, contactId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            contactId: contactId,
            options: options
        }, deleteCustomerNameBankContactOperationSpec, callback);
    };
    Api.prototype.getApplicationsNavigationNavigation = function (navigationType, options, callback) {
        return this.sendOperationRequest({
            navigationType: navigationType,
            options: options
        }, getApplicationsNavigationNavigationOperationSpec, callback);
    };
    Api.prototype.getApplicationsNavigationCustomerNavigation = function (customerId, navigationType, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            navigationType: navigationType,
            options: options
        }, getApplicationsNavigationCustomerNavigationOperationSpec, callback);
    };
    Api.prototype.getNavigationTag = function (relatedCategory, options, callback) {
        return this.sendOperationRequest({
            relatedCategory: relatedCategory,
            options: options
        }, getNavigationTagOperationSpec, callback);
    };
    Api.prototype.createCustomerNewsTop = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, createCustomerNewsTopOperationSpec, callback);
    };
    Api.prototype.createRelayNotificationsMobile = function (xTenantContext, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            options: options
        }, createRelayNotificationsMobileOperationSpec, callback);
    };
    Api.prototype.createCustomerNotification = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, createCustomerNotificationOperationSpec, callback);
    };
    Api.prototype.deleteCustomerNotification = function (customerId, notificationId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            notificationId: notificationId,
            options: options
        }, deleteCustomerNotificationOperationSpec, callback);
    };
    Api.prototype.getCustomerNotification = function (customerId, notificationId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            notificationId: notificationId,
            options: options
        }, getCustomerNotificationOperationSpec, callback);
    };
    Api.prototype.createCustomerNotificationSend = function (customerId, notificationId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            notificationId: notificationId,
            options: options
        }, createCustomerNotificationSendOperationSpec, callback);
    };
    Api.prototype.createCustomerNotificationRecall = function (customerId, notificationId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            notificationId: notificationId,
            options: options
        }, createCustomerNotificationRecallOperationSpec, callback);
    };
    Api.prototype.createCustomerNotificationsSearch = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, createCustomerNotificationsSearchOperationSpec, callback);
    };
    Api.prototype.getCustomersNotificationsTargets = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getCustomersNotificationsTargetsOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionOfferChoices = function (sessionId, offerId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            offerId: offerId,
            options: options
        }, getShoppingSessionOfferChoicesOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionOfferChoices = function (sessionId, offerId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            offerId: offerId,
            options: options
        }, deleteShoppingSessionOfferChoicesOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionOfferChoice = function (sessionId, offerId, itemCode, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            offerId: offerId,
            itemCode: itemCode,
            options: options
        }, getShoppingSessionOfferChoiceOperationSpec, callback);
    };
    Api.prototype.updateShoppingSessionOfferChoice = function (sessionId, offerId, itemCode, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            offerId: offerId,
            itemCode: itemCode,
            options: options
        }, updateShoppingSessionOfferChoiceOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionOfferChoice = function (sessionId, offerId, itemCode, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            offerId: offerId,
            itemCode: itemCode,
            options: options
        }, deleteShoppingSessionOfferChoiceOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionOfferOfferItems = function (sessionId, offerId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            offerId: offerId,
            options: options
        }, getShoppingSessionOfferOfferItemsOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionOffers = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, getShoppingSessionOffersOperationSpec, callback);
    };
    Api.prototype.getCustomerOnboardingTest = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerOnboardingTestOperationSpec, callback);
    };
    Api.prototype.updateCustomerOnboardingTest = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, updateCustomerOnboardingTestOperationSpec, callback);
    };
    Api.prototype.getTestsSmallSizeResponseOnline = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getTestsSmallSizeResponseOnlineOperationSpec, callback);
    };
    Api.prototype.getTestsMediumSizeResponseOnline = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getTestsMediumSizeResponseOnlineOperationSpec, callback);
    };
    Api.prototype.getTestsBigSizeResponseOnline = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getTestsBigSizeResponseOnlineOperationSpec, callback);
    };
    Api.prototype.createShoppingSessionOrder = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, createShoppingSessionOrderOperationSpec, callback);
    };
    Api.prototype.getOrders = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getOrdersOperationSpec, callback);
    };
    Api.prototype.getOrder = function (orderId, options, callback) {
        return this.sendOperationRequest({
            orderId: orderId,
            options: options
        }, getOrderOperationSpec, callback);
    };
    Api.prototype.deleteOrder = function (orderId, options, callback) {
        return this.sendOperationRequest({
            orderId: orderId,
            options: options
        }, deleteOrderOperationSpec, callback);
    };
    Api.prototype.getCustomerOrdersLastUnpaid = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerOrdersLastUnpaidOperationSpec, callback);
    };
    Api.prototype.getOrderRealtimeOrderTracking = function (orderId, options, callback) {
        return this.sendOperationRequest({
            orderId: orderId,
            options: options
        }, getOrderRealtimeOrderTrackingOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionPaymentMethods = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, getShoppingSessionPaymentMethodsOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionPaymentProviders = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, getShoppingSessionPaymentProvidersOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionPaymentProvider = function (sessionId, paymentProviderId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            paymentProviderId: paymentProviderId,
            options: options
        }, getShoppingSessionPaymentProviderOperationSpec, callback);
    };
    Api.prototype.getPaymentProvider = function (paymentProviderId, options, callback) {
        return this.sendOperationRequest({
            paymentProviderId: paymentProviderId,
            options: options
        }, getPaymentProviderOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionPayment = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, getShoppingSessionPaymentOperationSpec, callback);
    };
    Api.prototype.updateShoppingSessionPayment = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, updateShoppingSessionPaymentOperationSpec, callback);
    };
    Api.prototype.getPeriod = function (periodCode, options, callback) {
        return this.sendOperationRequest({
            periodCode: periodCode,
            options: options
        }, getPeriodOperationSpec, callback);
    };
    Api.prototype.getPeriods = function (offsets, options, callback) {
        return this.sendOperationRequest({
            offsets: offsets,
            options: options
        }, getPeriodsOperationSpec, callback);
    };
    Api.prototype.getPeriodsCurrentPeriod = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getPeriodsCurrentPeriodOperationSpec, callback);
    };
    Api.prototype.getConceptsPermissions = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getConceptsPermissionsOperationSpec, callback);
    };
    Api.prototype.getConceptPermission = function (conceptCode, options, callback) {
        return this.sendOperationRequest({
            conceptCode: conceptCode,
            options: options
        }, getConceptPermissionOperationSpec, callback);
    };
    Api.prototype.getCustomerConceptsPermissions = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerConceptsPermissionsOperationSpec, callback);
    };
    Api.prototype.getCustomerConceptPermission = function (customerId, conceptCode, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            conceptCode: conceptCode,
            options: options
        }, getCustomerConceptPermissionOperationSpec, callback);
    };
    Api.prototype.getProductsPermissions = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getProductsPermissionsOperationSpec, callback);
    };
    Api.prototype.getProductPermission = function (productCode, options, callback) {
        return this.sendOperationRequest({
            productCode: productCode,
            options: options
        }, getProductPermissionOperationSpec, callback);
    };
    Api.prototype.getCustomerProductPermission = function (customerId, productCode, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            productCode: productCode,
            options: options
        }, getCustomerProductPermissionOperationSpec, callback);
    };
    Api.prototype.getCustomerProductsPermissions = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerProductsPermissionsOperationSpec, callback);
    };
    Api.prototype.getCustomerRolesPermissions = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerRolesPermissionsOperationSpec, callback);
    };
    Api.prototype.getCustomerPersonalBeautyStore = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerPersonalBeautyStoreOperationSpec, callback);
    };
    Api.prototype.createCustomerPersonalBeautyStore = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, createCustomerPersonalBeautyStoreOperationSpec, callback);
    };
    Api.prototype.updateCustomerPersonalBeautyStore = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, updateCustomerPersonalBeautyStoreOperationSpec, callback);
    };
    Api.prototype.getCustomerPersonalBeautyStoreMetadata = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerPersonalBeautyStoreMetadataOperationSpec, callback);
    };
    Api.prototype.getApplicationsPersonalMenuLocalization = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getApplicationsPersonalMenuLocalizationOperationSpec, callback);
    };
    Api.prototype.getApplicationsPersonalMenu = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getApplicationsPersonalMenuOperationSpec, callback);
    };
    Api.prototype.getCustomerPersonalPerformance = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerPersonalPerformanceOperationSpec, callback);
    };
    Api.prototype.getCustomerPersonalProductsList = function (customerId, listId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            listId: listId,
            options: options
        }, getCustomerPersonalProductsListOperationSpec, callback);
    };
    Api.prototype.updateCustomerPersonalProductsList = function (customerId, listId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            listId: listId,
            options: options
        }, updateCustomerPersonalProductsListOperationSpec, callback);
    };
    Api.prototype.deleteCustomerPersonalProductsList = function (customerId, listId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            listId: listId,
            options: options
        }, deleteCustomerPersonalProductsListOperationSpec, callback);
    };
    Api.prototype.getCustomerPersonalProductsLists = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerPersonalProductsListsOperationSpec, callback);
    };
    Api.prototype.createCustomerPersonalProductsList = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, createCustomerPersonalProductsListOperationSpec, callback);
    };
    Api.prototype.getApplicationsPersonalProductsListLocalization = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getApplicationsPersonalProductsListLocalizationOperationSpec, callback);
    };
    Api.prototype.getApplicationsPersonalProductsListConfiguration = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getApplicationsPersonalProductsListConfigurationOperationSpec, callback);
    };
    Api.prototype.getCustomerPhones = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerPhonesOperationSpec, callback);
    };
    Api.prototype.createCustomerPhone = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, createCustomerPhoneOperationSpec, callback);
    };
    Api.prototype.updateCustomerPhone = function (customerId, telephoneId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            telephoneId: telephoneId,
            options: options
        }, updateCustomerPhoneOperationSpec, callback);
    };
    Api.prototype.deleteCustomerPhone = function (customerId, telephoneId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            telephoneId: telephoneId,
            options: options
        }, deleteCustomerPhoneOperationSpec, callback);
    };
    Api.prototype.getCustomerPhonesMetadata = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerPhonesMetadataOperationSpec, callback);
    };
    Api.prototype.getCustomerPhoneVerificationRequest = function (customerId, telephoneId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            telephoneId: telephoneId,
            options: options
        }, getCustomerPhoneVerificationRequestOperationSpec, callback);
    };
    Api.prototype.updateCustomerPhoneVerificationRequest = function (customerId, telephoneId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            telephoneId: telephoneId,
            options: options
        }, updateCustomerPhoneVerificationRequestOperationSpec, callback);
    };
    Api.prototype.getPopularProducts = function (type, options, callback) {
        return this.sendOperationRequest({
            type: type,
            options: options
        }, getPopularProductsOperationSpec, callback);
    };
    Api.prototype.getCustomerPreferences = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerPreferencesOperationSpec, callback);
    };
    Api.prototype.updateCustomerPreferences = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, updateCustomerPreferencesOperationSpec, callback);
    };
    Api.prototype.getCustomerPreferencesMetadata = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerPreferencesMetadataOperationSpec, callback);
    };
    Api.prototype.getConceptsPrices = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getConceptsPricesOperationSpec, callback);
    };
    Api.prototype.getConceptPrice = function (conceptCode, options, callback) {
        return this.sendOperationRequest({
            conceptCode: conceptCode,
            options: options
        }, getConceptPriceOperationSpec, callback);
    };
    Api.prototype.getCustomerConceptsPrices = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerConceptsPricesOperationSpec, callback);
    };
    Api.prototype.getCustomerConceptPrice = function (customerId, conceptCode, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            conceptCode: conceptCode,
            options: options
        }, getCustomerConceptPriceOperationSpec, callback);
    };
    Api.prototype.getProductsPrices = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getProductsPricesOperationSpec, callback);
    };
    Api.prototype.getCustomerProductPrice = function (customerId, productCode, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            productCode: productCode,
            options: options
        }, getCustomerProductPriceOperationSpec, callback);
    };
    Api.prototype.getCustomerProductsPrices = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerProductsPricesOperationSpec, callback);
    };
    Api.prototype.getProductBundle = function (productCode, options, callback) {
        return this.sendOperationRequest({
            productCode: productCode,
            options: options
        }, getProductBundleOperationSpec, callback);
    };
    Api.prototype.getProductBundles = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getProductBundlesOperationSpec, callback);
    };
    Api.prototype.getProductLabelsContent = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getProductLabelsContentOperationSpec, callback);
    };
    Api.prototype.getProductListTypeProductList = function (productListType, productListId, options, callback) {
        return this.sendOperationRequest({
            productListType: productListType,
            productListId: productListId,
            options: options
        }, getProductListTypeProductListOperationSpec, callback);
    };
    Api.prototype.getCustomerProductListTypeProductLists = function (customerId, productListType, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            productListType: productListType,
            options: options
        }, getCustomerProductListTypeProductListsOperationSpec, callback);
    };
    Api.prototype.createCustomerProductListTypeProductList = function (customerId, productListType, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            productListType: productListType,
            options: options
        }, createCustomerProductListTypeProductListOperationSpec, callback);
    };
    Api.prototype.getCustomerProductListTypeProductList = function (customerId, productListType, productListId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            productListType: productListType,
            productListId: productListId,
            options: options
        }, getCustomerProductListTypeProductListOperationSpec, callback);
    };
    Api.prototype.updateCustomerProductListTypeProductList = function (customerId, productListType, productListId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            productListType: productListType,
            productListId: productListId,
            options: options
        }, updateCustomerProductListTypeProductListOperationSpec, callback);
    };
    Api.prototype.deleteCustomerProductListTypeProductList = function (customerId, productListType, productListId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            productListType: productListType,
            productListId: productListId,
            options: options
        }, deleteCustomerProductListTypeProductListOperationSpec, callback);
    };
    Api.prototype.getApplicationsProductListingListing = function (productListingPageId, options, callback) {
        return this.sendOperationRequest({
            productListingPageId: productListingPageId,
            options: options
        }, getApplicationsProductListingListingOperationSpec, callback);
    };
    Api.prototype.getApplicationsProductListingPromoBanners = function (ids, options, callback) {
        return this.sendOperationRequest({
            ids: ids,
            options: options
        }, getApplicationsProductListingPromoBannersOperationSpec, callback);
    };
    Api.prototype.getProducts = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getProductsOperationSpec, callback);
    };
    Api.prototype.getProduct = function (productCode, options, callback) {
        return this.sendOperationRequest({
            productCode: productCode,
            options: options
        }, getProductOperationSpec, callback);
    };
    Api.prototype.getProductsLabels = function (productCodes, options, callback) {
        return this.sendOperationRequest({
            productCodes: productCodes,
            options: options
        }, getProductsLabelsOperationSpec, callback);
    };
    Api.prototype.getCustomerProfile = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerProfileOperationSpec, callback);
    };
    Api.prototype.updateCustomerProfile = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, updateCustomerProfileOperationSpec, callback);
    };
    Api.prototype.getCustomerProfileMetadata = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerProfileMetadataOperationSpec, callback);
    };
    Api.prototype.getApplicationsProfileLocalization = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getApplicationsProfileLocalizationOperationSpec, callback);
    };
    Api.prototype.getCustomerApplicationsProfileConfigurationsSections = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerApplicationsProfileConfigurationsSectionsOperationSpec, callback);
    };
    Api.prototype.getApplicationsProfileConfigurationExternalProfiles = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getApplicationsProfileConfigurationExternalProfilesOperationSpec, callback);
    };
    Api.prototype.getPromotion = function (promotionId, options, callback) {
        return this.sendOperationRequest({
            promotionId: promotionId,
            options: options
        }, getPromotionOperationSpec, callback);
    };
    Api.prototype.getPromotions = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getPromotionsOperationSpec, callback);
    };
    Api.prototype.createPushNotificationsInstallation = function (xTenantContext, acceptLanguage, xClientApplication, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            acceptLanguage: acceptLanguage,
            xClientApplication: xClientApplication,
            options: options
        }, createPushNotificationsInstallationOperationSpec, callback);
    };
    Api.prototype.createCustomerPushNotificationsInstallation = function (xTenantContext, xClientApplication, customerId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            xClientApplication: xClientApplication,
            customerId: customerId,
            options: options
        }, createCustomerPushNotificationsInstallationOperationSpec, callback);
    };
    Api.prototype.deleteCustomerPushNotificationsInstallation = function (xTenantContext, xClientApplication, customerId, installationId, options, callback) {
        return this.sendOperationRequest({
            xTenantContext: xTenantContext,
            xClientApplication: xClientApplication,
            customerId: customerId,
            installationId: installationId,
            options: options
        }, deleteCustomerPushNotificationsInstallationOperationSpec, callback);
    };
    Api.prototype.createPushNotificationsRegistration = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, createPushNotificationsRegistrationOperationSpec, callback);
    };
    Api.prototype.deletePushNotificationsApplicationRegistrationId = function (applicationKey, registrationId, options, callback) {
        return this.sendOperationRequest({
            applicationKey: applicationKey,
            registrationId: registrationId,
            options: options
        }, deletePushNotificationsApplicationRegistrationIdOperationSpec, callback);
    };
    Api.prototype.deletePushNotificationsApplicationDeviceToken = function (applicationKey, deviceToken, options, callback) {
        return this.sendOperationRequest({
            applicationKey: applicationKey,
            deviceToken: deviceToken,
            options: options
        }, deletePushNotificationsApplicationDeviceTokenOperationSpec, callback);
    };
    Api.prototype.getApplicationsRealTimeOrderTrackingLocalization = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getApplicationsRealTimeOrderTrackingLocalizationOperationSpec, callback);
    };
    Api.prototype.getCustomerRecurringPaymentCards = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerRecurringPaymentCardsOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionReferral = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, getShoppingSessionReferralOperationSpec, callback);
    };
    Api.prototype.createShoppingSessionReferral = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, createShoppingSessionReferralOperationSpec, callback);
    };
    Api.prototype.createCustomerConsultant = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, createCustomerConsultantOperationSpec, callback);
    };
    Api.prototype.createConsultant = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, createConsultantOperationSpec, callback);
    };
    Api.prototype.getRegistrationMetadata = function (registrationType, options, callback) {
        return this.sendOperationRequest({
            registrationType: registrationType,
            options: options
        }, getRegistrationMetadataOperationSpec, callback);
    };
    Api.prototype.getProductRelations = function (productCode, options, callback) {
        return this.sendOperationRequest({
            productCode: productCode,
            options: options
        }, getProductRelationsOperationSpec, callback);
    };
    Api.prototype.createReportingReportsInstall = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, createReportingReportsInstallOperationSpec, callback);
    };
    Api.prototype.getCustomerRequiredTerms = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerRequiredTermsOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionSectionSectionItems = function (sessionId, sectionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            sectionId: sectionId,
            options: options
        }, getShoppingSessionSectionSectionItemsOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionSections = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, getShoppingSessionSectionsOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionSectionSuggestions = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, getShoppingSessionSectionSuggestionsOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionSectionWishlistItems = function (sessionId, sectionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            sectionId: sectionId,
            options: options
        }, getShoppingSessionSectionWishlistItemsOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionSectionWishlistItems = function (sessionId, sectionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            sectionId: sectionId,
            options: options
        }, deleteShoppingSessionSectionWishlistItemsOperationSpec, callback);
    };
    Api.prototype.createShoppingSessionSectionWishlist = function (sessionId, sectionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            sectionId: sectionId,
            options: options
        }, createShoppingSessionSectionWishlistOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionSectionWishlist = function (sessionId, sectionId, itemCode, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            sectionId: sectionId,
            itemCode: itemCode,
            options: options
        }, getShoppingSessionSectionWishlistOperationSpec, callback);
    };
    Api.prototype.updateShoppingSessionSectionWishlist = function (sessionId, sectionId, itemCode, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            sectionId: sectionId,
            itemCode: itemCode,
            options: options
        }, updateShoppingSessionSectionWishlistOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionSectionWishlist = function (sessionId, sectionId, itemCode, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            sectionId: sectionId,
            itemCode: itemCode,
            options: options
        }, deleteShoppingSessionSectionWishlistOperationSpec, callback);
    };
    Api.prototype.getApplicationsNetworkCommunicationConfiguration = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getApplicationsNetworkCommunicationConfigurationOperationSpec, callback);
    };
    Api.prototype.getApplicationsNetworkCommunicationLocalization = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getApplicationsNetworkCommunicationLocalizationOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionShippingJokerChoice = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, getShoppingSessionShippingJokerChoiceOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionShippingJokerChoice = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, deleteShoppingSessionShippingJokerChoiceOperationSpec, callback);
    };
    Api.prototype.createShoppingSessionShippingJokerChoice = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, createShoppingSessionShippingJokerChoiceOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionShippingJokerChoices = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, getShoppingSessionShippingJokerChoicesOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionShippingJokerChoices = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, deleteShoppingSessionShippingJokerChoicesOperationSpec, callback);
    };
    Api.prototype.updateShoppingSessionShippingJokerChoices = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, updateShoppingSessionShippingJokerChoicesOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionShippingJokers = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, getShoppingSessionShippingJokersOperationSpec, callback);
    };
    Api.prototype.createShoppingSessionShoppingBag = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, createShoppingSessionShoppingBagOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionShoppingBag = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, deleteShoppingSessionShoppingBagOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionShoppingBagAggregatedItems = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, getShoppingSessionShoppingBagAggregatedItemsOperationSpec, callback);
    };
    Api.prototype.updateShoppingSessionShoppingBagBagItem = function (sessionId, bagItemId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            bagItemId: bagItemId,
            options: options
        }, updateShoppingSessionShoppingBagBagItemOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionShoppingBagBagItem = function (sessionId, bagItemId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            bagItemId: bagItemId,
            options: options
        }, deleteShoppingSessionShoppingBagBagItemOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionShoppingBagBagItemBackorder = function (sessionId, bagItemId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            bagItemId: bagItemId,
            options: options
        }, getShoppingSessionShoppingBagBagItemBackorderOperationSpec, callback);
    };
    Api.prototype.createShoppingSessionShoppingBagBagItemBackorder = function (sessionId, bagItemId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            bagItemId: bagItemId,
            options: options
        }, createShoppingSessionShoppingBagBagItemBackorderOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionShoppingBagBagItemBackorder = function (sessionId, bagItemId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            bagItemId: bagItemId,
            options: options
        }, deleteShoppingSessionShoppingBagBagItemBackorderOperationSpec, callback);
    };
    Api.prototype.createShoppingSessionShoppingBagBagItem = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, createShoppingSessionShoppingBagBagItemOperationSpec, callback);
    };
    Api.prototype.updateShoppingSessionShoppingBagBagItems = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, updateShoppingSessionShoppingBagBagItemsOperationSpec, callback);
    };
    Api.prototype.updateApplicationsWechatpbsShoppingSessionShoppingBagBagItems = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, updateApplicationsWechatpbsShoppingSessionShoppingBagBagItemsOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionMessages = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, getShoppingSessionMessagesOperationSpec, callback);
    };
    Api.prototype.createShoppingSession = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, createShoppingSessionOperationSpec, callback);
    };
    Api.prototype.getShoppingSession = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, getShoppingSessionOperationSpec, callback);
    };
    Api.prototype.getCustomerSocialEntityTypeSocialEntities = function (customerId, socialEntityType, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            socialEntityType: socialEntityType,
            options: options
        }, getCustomerSocialEntityTypeSocialEntitiesOperationSpec, callback);
    };
    Api.prototype.getSocialEntityTypeSocialEntitiesStat = function (socialEntityType, socialEntityId, options, callback) {
        return this.sendOperationRequest({
            socialEntityType: socialEntityType,
            socialEntityId: socialEntityId,
            options: options
        }, getSocialEntityTypeSocialEntitiesStatOperationSpec, callback);
    };
    Api.prototype.getSocialEntityTypeSocialEntitiesStats = function (socialEntityType, options, callback) {
        return this.sendOperationRequest({
            socialEntityType: socialEntityType,
            options: options
        }, getSocialEntityTypeSocialEntitiesStatsOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionSpecialOffer = function (sessionId, offerId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            offerId: offerId,
            options: options
        }, getShoppingSessionSpecialOfferOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionSpecialOfferChoice = function (sessionId, offerId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            offerId: offerId,
            options: options
        }, getShoppingSessionSpecialOfferChoiceOperationSpec, callback);
    };
    Api.prototype.updateShoppingSessionSpecialOfferChoice = function (sessionId, offerId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            offerId: offerId,
            options: options
        }, updateShoppingSessionSpecialOfferChoiceOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionSpecialOfferChoice = function (sessionId, offerId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            offerId: offerId,
            options: options
        }, deleteShoppingSessionSpecialOfferChoiceOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionSpecialOfferReplacements = function (sessionId, offerId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            offerId: offerId,
            options: options
        }, getShoppingSessionSpecialOfferReplacementsOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionSpecialOffers = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, getShoppingSessionSpecialOffersOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionSpecialOfferVoucher = function (sessionId, offerId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            offerId: offerId,
            options: options
        }, getShoppingSessionSpecialOfferVoucherOperationSpec, callback);
    };
    Api.prototype.createShoppingSessionSpecialOfferVoucherChoice = function (sessionId, offerId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            offerId: offerId,
            options: options
        }, createShoppingSessionSpecialOfferVoucherChoiceOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionSpecialOfferVoucherChoice = function (sessionId, choiceId, offerId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            choiceId: choiceId,
            offerId: offerId,
            options: options
        }, deleteShoppingSessionSpecialOfferVoucherChoiceOperationSpec, callback);
    };
    Api.prototype.getCustomerStepsToSuccessTasks = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerStepsToSuccessTasksOperationSpec, callback);
    };
    Api.prototype.getCustomerStepsToSuccessTask = function (customerId, taskId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            taskId: taskId,
            options: options
        }, getCustomerStepsToSuccessTaskOperationSpec, callback);
    };
    Api.prototype.createCustomerStepsToSuccessComplete = function (taskId, customerId, options, callback) {
        return this.sendOperationRequest({
            taskId: taskId,
            customerId: customerId,
            options: options
        }, createCustomerStepsToSuccessCompleteOperationSpec, callback);
    };
    Api.prototype.getCustomerSubscriptionConfiguration = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerSubscriptionConfigurationOperationSpec, callback);
    };
    Api.prototype.getCustomerSubscriptionAvailabilities = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerSubscriptionAvailabilitiesOperationSpec, callback);
    };
    Api.prototype.getCustomerSubscriptionTypes = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, getCustomerSubscriptionTypesOperationSpec, callback);
    };
    Api.prototype.createCustomerSubscriptionInstruction = function (customerId, options, callback) {
        return this.sendOperationRequest({
            customerId: customerId,
            options: options
        }, createCustomerSubscriptionInstructionOperationSpec, callback);
    };
    Api.prototype.getApplicationsSubscriptionWizardLocalization = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getApplicationsSubscriptionWizardLocalizationOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionSummary = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, getShoppingSessionSummaryOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionSummaryAccounts = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, getShoppingSessionSummaryAccountsOperationSpec, callback);
    };
    Api.prototype.getApplicationsSupportCenterCategories = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getApplicationsSupportCenterCategoriesOperationSpec, callback);
    };
    Api.prototype.getApplicationsSupportCenterCategory = function (categoryId, options, callback) {
        return this.sendOperationRequest({
            categoryId: categoryId,
            options: options
        }, getApplicationsSupportCenterCategoryOperationSpec, callback);
    };
    Api.prototype.getApplicationsSupportCenterLocalization = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getApplicationsSupportCenterLocalizationOperationSpec, callback);
    };
    Api.prototype.getApplicationsSupportCenterFeaturedFaqs = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getApplicationsSupportCenterFeaturedFaqsOperationSpec, callback);
    };
    Api.prototype.getApplicationsSupportCenterSearch = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getApplicationsSupportCenterSearchOperationSpec, callback);
    };
    Api.prototype.getProductsTagGroups = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getProductsTagGroupsOperationSpec, callback);
    };
    Api.prototype.getTermHtml = function (termId, options, callback) {
        return this.sendOperationRequest({
            termId: termId,
            options: options
        }, getTermHtmlOperationSpec, callback);
    };
    Api.prototype.getTestPing = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getTestPingOperationSpec, callback);
    };
    Api.prototype.getSettingsClientSettingCustomer = function (settingId, customerId, options, callback) {
        return this.sendOperationRequest({
            settingId: settingId,
            customerId: customerId,
            options: options
        }, getSettingsClientSettingCustomerOperationSpec, callback);
    };
    Api.prototype.updateSettingsClientSettingCustomer = function (settingId, customerId, options, callback) {
        return this.sendOperationRequest({
            settingId: settingId,
            customerId: customerId,
            options: options
        }, updateSettingsClientSettingCustomerOperationSpec, callback);
    };
    Api.prototype.deleteSettingsClientSettingCustomer = function (settingId, customerId, options, callback) {
        return this.sendOperationRequest({
            settingId: settingId,
            customerId: customerId,
            options: options
        }, deleteSettingsClientSettingCustomerOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionVoucherCodes = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, getShoppingSessionVoucherCodesOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionVoucherCodes = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, deleteShoppingSessionVoucherCodesOperationSpec, callback);
    };
    Api.prototype.createShoppingSessionVoucherCode = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, createShoppingSessionVoucherCodeOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionVoucherCode = function (sessionId, voucherCode, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            voucherCode: voucherCode,
            options: options
        }, getShoppingSessionVoucherCodeOperationSpec, callback);
    };
    Api.prototype.deleteShoppingSessionVoucherCode = function (sessionId, voucherCode, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            voucherCode: voucherCode,
            options: options
        }, deleteShoppingSessionVoucherCodeOperationSpec, callback);
    };
    Api.prototype.getVouchers = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getVouchersOperationSpec, callback);
    };
    Api.prototype.getShoppingSessionVouchers = function (sessionId, options, callback) {
        return this.sendOperationRequest({
            sessionId: sessionId,
            options: options
        }, getShoppingSessionVouchersOperationSpec, callback);
    };
    Api.prototype.getApplicationsVouchersLocalization = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, getApplicationsVouchersLocalizationOperationSpec, callback);
    };
    Api.prototype.createLoginProvidersWeChatExternalAccount = function (options, callback) {
        return this.sendOperationRequest({
            options: options
        }, createLoginProvidersWeChatExternalAccountOperationSpec, callback);
    };
    Api.prototype.getLoginProvidersWeChatExternalAccountPlatforms = function (unionId, options, callback) {
        return this.sendOperationRequest({
            unionId: unionId,
            options: options
        }, getLoginProvidersWeChatExternalAccountPlatformsOperationSpec, callback);
    };
    Api.prototype.createLoginProvidersWeChatExternalAccountPlatform = function (unionId, options, callback) {
        return this.sendOperationRequest({
            unionId: unionId,
            options: options
        }, createLoginProvidersWeChatExternalAccountPlatformOperationSpec, callback);
    };
    return Api;
}(ApiContext));
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var createCustomerAcceptedTermOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/acceptedTerms",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersAcceptedTermDto
    },
    responses: {
        204: {},
        default: {}
    },
    serializer: serializer
};
var updateAccountsMyChangePasswordOperationSpec = {
    httpMethod: "PUT",
    path: "accounts/my/changePassword",
    queryParameters: [
        Parameters.loginString
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalAccountsChangePasswordDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getAccountsMyOperationSpec = {
    httpMethod: "GET",
    path: "accounts/my",
    queryParameters: [
        Parameters.loginString
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalAccountsAccountInfoDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createAccountsMySendTemporaryPasswordOperationSpec = {
    httpMethod: "POST",
    path: "accounts/my/sendTemporaryPassword",
    queryParameters: [
        Parameters.loginString,
        Parameters.channels
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateAccountsMyResetPasswordOperationSpec = {
    httpMethod: "PUT",
    path: "accounts/my/resetPassword",
    queryParameters: [
        Parameters.loginString
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalAccountsResetPasswordDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getAccountsChangePasswordMetadataOperationSpec = {
    httpMethod: "GET",
    path: "accounts/changePasswordMetadata",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalAccountsMetadataChangePasswordMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var getAccountsMyPermissionsOperationSpec = {
    httpMethod: "GET",
    path: "accounts/my/permissions",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalAccountsPermissionsDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerAddressesOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/addresses",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersAddressesDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerAddressOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/addresses",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersAddressDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateCustomerAddressOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/addresses/{addressId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.addressId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersAddressDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerAddressOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/addresses/{addressId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.addressId1
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerAddressesMetadataOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/addresses/metadata",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataAddressMetadataDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getAddressFormatsOperationSpec = {
    httpMethod: "GET",
    path: "addressFormats",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersAddressFormatCollectionDto
        },
        default: {}
    },
    serializer: serializer
};
var getAddressFormatOperationSpec = {
    httpMethod: "GET",
    path: "addressFormats/{type}",
    urlParameters: [
        Parameters.type0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersAddressFormatDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerApprovalOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/approval",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSharedApprovalDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateCustomerApprovalOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/approval",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalSharedApprovalDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerApprovalMetadataOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/approval/metadata",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataCustomerApprovalMetadataDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getAtpClusterAtpOperationSpec = {
    httpMethod: "GET",
    path: "atpClusters/{atpClusterId}/atps/{itemCode}",
    urlParameters: [
        Parameters.atpClusterId,
        Parameters.itemCode0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {},
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getAtpClusterAtpsOperationSpec = {
    httpMethod: "GET",
    path: "atpClusters/{atpClusterId}/atps",
    urlParameters: [
        Parameters.atpClusterId
    ],
    queryParameters: [
        Parameters.itemCodes
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {},
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getAtpClusterOperationSpec = {
    httpMethod: "GET",
    path: "atpClusters/{atpClusterId}",
    urlParameters: [
        Parameters.atpClusterId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {},
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getAtpClustersOperationSpec = {
    httpMethod: "GET",
    path: "atpClusters",
    queryParameters: [
        Parameters.deliveryChannelId0,
        Parameters.customerId1,
        Parameters.addressId2
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {},
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerAutoshipConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/autoshipConfiguration",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersSubscriptionConfigurationDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerAutoshipAvailabilitiesOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/autoshipAvailabilities",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.products
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersSubscriptionProductsAvailabilityDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerAutoshipTypesOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/autoshipTypes",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.product
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersAutoshipTypesDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerAutoshipLegalArticlesOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/autoshipLegalArticles",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersAutoshipLegalArticlesDto
        },
        default: {}
    },
    serializer: serializer
};
var createCustomerAutoshipInstructionOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/autoshipInstructions",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersAutoshipInstructionDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersAutoshipInstructionDto
        },
        default: {}
    },
    serializer: serializer
};
var getConceptAvailabilityOperationSpec = {
    httpMethod: "GET",
    path: "concepts/{conceptCode}/availability",
    urlParameters: [
        Parameters.conceptCode
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsConceptAvailabilityDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerConceptsAvailabilitiesOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/concepts/availabilities",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalConceptsAvailabilitiesQueryDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsConceptsAvailabilityDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getConceptsAvailabilitiesOperationSpec = {
    httpMethod: "POST",
    path: "concepts/availabilities",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalConceptsAvailabilitiesQueryDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsConceptsAvailabilityDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerConceptAvailabilityOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/concepts/{conceptCode}/availability",
    urlParameters: [
        Parameters.customerId0,
        Parameters.conceptCode
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsConceptAvailabilityDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerProductAvailabilityOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/products/{productCode}/availability",
    urlParameters: [
        Parameters.customerId0,
        Parameters.productCode
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsAvailabilityDto
        },
        default: {}
    },
    serializer: serializer
};
var getProductAvailabilityOperationSpec = {
    httpMethod: "GET",
    path: "products/{productCode}/availability",
    urlParameters: [
        Parameters.productCode
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsAvailabilityDto
        },
        default: {}
    },
    serializer: serializer
};
var getProductsAvailabilityOperationSpec = {
    httpMethod: "POST",
    path: "products/availability",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalProductsProductAvailabilityQueryDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsProductsAvailabilityDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerProductsAvailabilityOperationSpec = {
    httpMethod: "POST",
    path: "customer/{customerId}/products/availability",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalProductsProductAvailabilityQueryDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsProductsAvailabilityDto
        },
        default: {}
    },
    serializer: serializer
};
var getBackInStockNotificationsOperationSpec = {
    httpMethod: "GET",
    path: "backInStockNotifications",
    queryParameters: [
        Parameters.productCodes0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalBackInStockNotificationsBackInStockNotificationCollectionDto
        },
        default: {}
    },
    serializer: serializer
};
var createBackInStockNotificationSubscriptionOperationSpec = {
    httpMethod: "POST",
    path: "backInStockNotificationSubscriptions",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalBackInStockNotificationsBackInStockNotificationSubscriptionDto
    },
    responses: {
        204: {},
        default: {}
    },
    serializer: serializer
};
var getBackInStockNotificationsConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "backInStockNotificationsConfiguration",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalBackInStockNotificationsBackInStockNotificationsConfigurationDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerBackInStockNotificationsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/backInStockNotifications",
    urlParameters: [
        Parameters.customerId2
    ],
    queryParameters: [
        Parameters.productCodes0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalBackInStockNotificationsBackInStockNotificationCollectionDto
        },
        default: {}
    },
    serializer: serializer
};
var createCustomerBackInStockNotificationSubscriptionOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/backInStockNotificationSubscriptions",
    urlParameters: [
        Parameters.customerId2
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalBackInStockNotificationsBackInStockNotificationSubscriptionDto
    },
    responses: {
        204: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerBankAccountsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/bankAccounts",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersBankAccountsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerBankAccountOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/bankAccounts",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersBankAccountDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateCustomerBankAccountOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/bankAccounts/{bankAccountId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.bankAccountId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersBankAccountDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerBankAccountOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/bankAccounts/{bankAccountId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.bankAccountId1
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerBankAccountsMetadataOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/bankAccounts/metadata",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataBankAccountMetadataDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getBankBranchesOperationSpec = {
    httpMethod: "GET",
    path: "bankBranches",
    queryParameters: [
        Parameters.market,
        Parameters.country0,
        Parameters.region0,
        Parameters.province0,
        Parameters.district0,
        Parameters.area0,
        Parameters.city0,
        Parameters.locality0,
        Parameters.street0,
        Parameters.zipCode0,
        Parameters.name,
        Parameters.bankId0,
        Parameters.bankBranchIds
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalFinanceBankBranchesDto
        },
        default: {}
    },
    serializer: serializer
};
var getBankBranchOperationSpec = {
    httpMethod: "GET",
    path: "bankBranches/{bankBranchId}",
    urlParameters: [
        Parameters.bankBranchId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalFinanceBankBranchDto
        },
        default: {}
    },
    serializer: serializer
};
var getBanksOperationSpec = {
    httpMethod: "GET",
    path: "banks",
    queryParameters: [
        Parameters.bankIds
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalFinanceBanksDto
        },
        default: {}
    },
    serializer: serializer
};
var getBankOperationSpec = {
    httpMethod: "GET",
    path: "banks/{bankId}",
    urlParameters: [
        Parameters.bankId1
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalFinanceBankDto
        },
        default: {}
    },
    serializer: serializer
};
var updateShoppingSessionBasketOfferOperationSpec = {
    httpMethod: "PUT",
    path: "shoppingSessions/{sessionId}/basketOffers/{offerId}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionBasketOffersOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/basketOffers",
    urlParameters: [
        Parameters.sessionId
    ],
    queryParameters: [
        Parameters.top0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingBasketOffersDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getBlockingCodesOperationSpec = {
    httpMethod: "GET",
    path: "blockingCodes",
    queryParameters: [
        Parameters.blockingType,
        Parameters.blockingCodeIds
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalBlockingCodesBlockingCodesDto
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerBlockingsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/blockings",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.blockingState,
        Parameters.blockingCodeIds
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersBlockingsDto
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getBrandsOperationSpec = {
    httpMethod: "GET",
    path: "brands",
    queryParameters: [
        Parameters.categoryId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsBrandsDto
        },
        default: {}
    },
    serializer: serializer
};
var createCallInteractionOperationSpec = {
    httpMethod: "POST",
    path: "callInteractions",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCallInteractionsCallInteractionDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCampaignPointsOperationSpec = {
    httpMethod: "GET",
    path: "campaigns/{campaignId}/points",
    urlParameters: [
        Parameters.campaignId
    ],
    queryParameters: [
        Parameters.customerId3
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCampaignsCampaignPointsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCampaignsOperationSpec = {
    httpMethod: "GET",
    path: "campaigns",
    queryParameters: [
        Parameters.campaignType0,
        Parameters.customerId1,
        Parameters.potentialQualification
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCampaignsCampaignsDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCampaignsWelcomeProgramTargetsOperationSpec = {
    httpMethod: "GET",
    path: "campaigns/welcomeProgram/targets",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCampaignsCampaignTargetsDto
        },
        default: {}
    },
    serializer: serializer
};
var getCampaignsActivityProgramTargetsOperationSpec = {
    httpMethod: "GET",
    path: "campaigns/activityProgram/targets",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCampaignsCampaignTargetsDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerCampaignBenefitsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/campaigns/{campaignType}/benefits",
    urlParameters: [
        Parameters.customerId0,
        Parameters.campaignType1
    ],
    queryParameters: [
        Parameters.productCodes1
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsCampaignBenefitsDto
        },
        default: {}
    },
    serializer: serializer
};
var getCataloguesCatalogueContentOperationSpec = {
    httpMethod: "GET",
    path: "catalogues/catalogue/{catalogueCode}/content",
    urlParameters: [
        Parameters.catalogueCode1
    ],
    queryParameters: [
        Parameters.catalogueCode,
        Parameters.itemCode1
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCataloguesCatalogueContentDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCatalogueCatalogueItemOperationSpec = {
    httpMethod: "GET",
    path: "catalogues/{catalogueId}/catalogueItems/{catalogueItemId}",
    urlParameters: [
        Parameters.catalogueId,
        Parameters.catalogueItemId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCataloguesCatalogueItemDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCatalogueCatalogueItemsOperationSpec = {
    httpMethod: "GET",
    path: "catalogues/{catalogueId}/catalogueItems",
    urlParameters: [
        Parameters.catalogueId
    ],
    queryParameters: [
        Parameters.isStandardItem,
        Parameters.skip0,
        Parameters.top1
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCataloguesCatalogueItemsDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCataloguesOperationSpec = {
    httpMethod: "GET",
    path: "catalogues",
    queryParameters: [
        Parameters.periodId,
        Parameters.typeCode
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCataloguesCataloguesDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getSocialMediaLibraryCategoryOperationSpec = {
    httpMethod: "GET",
    path: "socialMediaLibrary/categories/{categoryId}",
    urlParameters: [
        Parameters.categoryId1
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSocialMediaLibraryCategoryDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getSocialMediaLibraryCategoriesOperationSpec = {
    httpMethod: "GET",
    path: "socialMediaLibrary/categories",
    queryParameters: [
        Parameters.search,
        Parameters.top2,
        Parameters.skip0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSocialMediaLibraryCategoriesDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCategoriesOperationSpec = {
    httpMethod: "GET",
    path: "categories",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsCategoriesDto
        },
        default: {}
    },
    serializer: serializer
};
var getConceptLabelsOperationSpec = {
    httpMethod: "GET",
    path: "conceptLabels",
    queryParameters: [
        Parameters.conceptCodes
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsConceptsLabelsDto
        },
        default: {}
    },
    serializer: serializer
};
var getConceptsOperationSpec = {
    httpMethod: "POST",
    path: "concepts",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalConceptsQueryDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsConceptsDto
        },
        400: {},
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getConceptOperationSpec = {
    httpMethod: "GET",
    path: "concepts/{conceptCode}",
    urlParameters: [
        Parameters.conceptCode
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsConceptDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsSocialMediaLibraryConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "applications/socialMediaLibrary/configuration",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSocialMediaLibraryConfigurationDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsSocialMediaLibraryLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "applications/socialMediaLibrary/localization",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSharedLocalizationDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerConfirmationOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/confirmation",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersConfirmationDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getLoginProvidersWeChatExternalAccountConnectedUserOperationSpec = {
    httpMethod: "GET",
    path: "login/providers/weChat/externalAccount/{unionId}/connectedUser",
    urlParameters: [
        Parameters.unionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalLoginConnectedUserDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getConsultantTitlesOperationSpec = {
    httpMethod: "GET",
    path: "consultantTitles",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConsultantsTitlesDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getConsultantCustomerIdOperationSpec = {
    httpMethod: "GET",
    path: "consultants/{consultantNumber}/customerId",
    urlParameters: [
        Parameters.consultantNumber
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        401: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerConsultantNumberOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/consultantNumber",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        401: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerConsultantNumberDeprecatedOperationSpec = {
    httpMethod: "GET",
    path: "customer/{customerId}/consultantNumber",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        401: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getConsultantCustomerIdDeprecatedOperationSpec = {
    httpMethod: "GET",
    path: "consultant/{consultantNumber}/customerId",
    urlParameters: [
        Parameters.consultantNumber
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        401: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerCustomerAttributeDeprecatedOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/customerAttributes/{customerAttributeTypeId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.customerAttributeTypeId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersAttributeDto
        },
        default: {}
    },
    serializer: serializer
};
var updateCustomerCustomerAttributeDeprecatedOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/customerAttributes/{customerAttributeTypeId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.customerAttributeTypeId1
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersAttributeDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerCustomerAttributesDeprecatedOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/customerAttributes",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersAttributesDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerAttributesIdentityCardDeprecatedOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/attributes/identityCard",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersDocumentsAttributeDto
        },
        default: {}
    },
    serializer: serializer
};
var updateCustomerAttributesIdentityCardDeprecatedOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/attributes/identityCard",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersDocumentsAttributeDto
    },
    responses: {
        204: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerAttributesEInvoiceApprovalDeprecatedOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/attributes/eInvoiceApproval",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersBooleanAttributeDto
        },
        default: {}
    },
    serializer: serializer
};
var updateCustomerAttributesEInvoiceApprovalDeprecatedOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/attributes/eInvoiceApproval",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersBooleanAttributeDto
    },
    responses: {
        204: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerAttributesMetadataDeprecatedOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/attributesMetadata",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataAttributesMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerIdentityCardOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/identityCard",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersDocumentsAttributeDto
        },
        default: {}
    },
    serializer: serializer
};
var updateCustomerIdentityCardOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/identityCard",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersDocumentsAttributeDto
    },
    responses: {
        204: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerEInvoiceApprovalOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/eInvoiceApproval",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersBooleanAttributeDto
        },
        default: {}
    },
    serializer: serializer
};
var updateCustomerEInvoiceApprovalOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/eInvoiceApproval",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersBooleanAttributeDto
    },
    responses: {
        204: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerMetadataOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/metadata",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataAttributesMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerConceptLabelsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/conceptLabels",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.conceptCodes
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsConceptsLabelsDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerWelcomeProgramOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/welcomeProgram",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersWelcomeProgramDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerActivityProgramOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/activityProgram",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersActivityProgramDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerRecruitmentCampaignOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/recruitmentCampaign",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersRecruitmentCampaignDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerPersonalSalesOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/personalSales",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersPersonalSalesDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerPersonalSalesHistoryOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/personalSalesHistory",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersCustomerPersonalSalesHistoryDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerLoyaltyProgramOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/loyaltyProgram",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersLoyaltyProgramDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerProductsLabelsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/productsLabels",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.productCodes1
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsProductsLabelsDto
        },
        default: {}
    },
    serializer: serializer
};
var createReportsCustomerStatusOperationSpec = {
    httpMethod: "POST",
    path: "reports/customerStatuses",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalReportsCustomerStatusesRequestDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalReportsCustomerStatusesResponseDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerLocalConsultantTitleOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/localConsultantTitle",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersLocalConsultantTitleDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerDeliveryAddressOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/deliveryAddresses/{deliveryAddressId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.deliveryAddressId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersDeliveryAddressDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getDeliveryChannelOperationSpec = {
    httpMethod: "GET",
    path: "deliveryChannels/{deliveryChannelId}",
    urlParameters: [
        Parameters.deliveryChannelId1
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalDeliveryDeliveryChannelDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getDeliveryChannelAddressOperationSpec = {
    httpMethod: "GET",
    path: "deliveryChannels/{deliveryChannelId}/address",
    urlParameters: [
        Parameters.deliveryChannelId1
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSharedAddressDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionDeliveryChannelsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/deliveryChannels",
    urlParameters: [
        Parameters.sessionId
    ],
    queryParameters: [
        Parameters.searchTerm,
        Parameters.method,
        Parameters.skip0,
        Parameters.top1
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingDeliveryChannelsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionDeliveryChannelOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/deliveryChannels/{deliveryChannelId}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.deliveryChannelId1
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingDeliveryChannelDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionDeliveryMethodsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/deliveryMethods",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingDeliveryMethodsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionDeliveryOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/delivery",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingDeliveryDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateShoppingSessionDeliveryOperationSpec = {
    httpMethod: "PUT",
    path: "shoppingSessions/{sessionId}/delivery",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingDeliveryDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingDeliveryDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCourierWayBillNumberDeliveryStatusOperationSpec = {
    httpMethod: "POST",
    path: "couriers/{courierId}/wayBillNumbers/{wayBillNumber}/deliveryStatuses",
    urlParameters: [
        Parameters.courierId,
        Parameters.wayBillNumber
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalDeliveryDeliveryStatusDto
    },
    responses: {
        202: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerDocumentOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/documents",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.documentTypeId,
        Parameters.isTemporary
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    formDataParameters: [
        Parameters.file
    ],
    contentType: "multipart/form-data",
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        415: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerDocumentImageOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/documents/{documentId}/image",
    urlParameters: [
        Parameters.customerId0,
        Parameters.documentId
    ],
    queryParameters: [
        Parameters.width,
        Parameters.height
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Object"
                }
            }
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerDocumentOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/documents/{documentId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.documentId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Object"
                }
            }
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerDocumentOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/documents/{documentId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.documentId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerDocumentsInfosOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/documents/infos",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.documentIds,
        Parameters.documentTypeId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersDocumentInfoDto"
                        }
                    }
                }
            }
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getDocumentTypesOperationSpec = {
    httpMethod: "GET",
    path: "documentTypes",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersDocumentTypeDto"
                        }
                    }
                }
            }
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var createDocumentOperationSpec = {
    httpMethod: "POST",
    path: "documents",
    queryParameters: [
        Parameters.documentTypeId,
        Parameters.isTemporary
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    formDataParameters: [
        Parameters.file
    ],
    contentType: "multipart/form-data",
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        415: {},
        default: {}
    },
    serializer: serializer
};
var getDocumentImageOperationSpec = {
    httpMethod: "GET",
    path: "documents/{documentId}/image",
    urlParameters: [
        Parameters.documentId
    ],
    queryParameters: [
        Parameters.width,
        Parameters.height
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Object"
                }
            }
        },
        401: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getDocumentOperationSpec = {
    httpMethod: "GET",
    path: "documents/{documentId}",
    urlParameters: [
        Parameters.documentId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Object"
                }
            }
        },
        401: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getDocumentsInfosOperationSpec = {
    httpMethod: "GET",
    path: "documents/infos",
    queryParameters: [
        Parameters.documentIds
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersDocumentInfoDto"
                        }
                    }
                }
            }
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerDocumentApprovalDeprecatedOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/documents/{documentId}/approval",
    urlParameters: [
        Parameters.customerId0,
        Parameters.documentId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersDocumentApprovalDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerDocumentsApprovalsDeprecatedOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/documents/approvals",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.approvalStates
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersDocumentApprovalsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerDocumentApprovalsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/documentApprovals",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.approvalStates,
        Parameters.documentIds
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersDocumentApprovalsDto
        },
        default: {}
    },
    serializer: serializer
};
var createCustomerDocumentApprovalOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/documentApprovals",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersDocumentApprovalDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerDocumentApprovalOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/documentApprovals/{documentApprovalId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.documentApprovalId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersDocumentApprovalDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerDownlinePerformanceOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/downlinePerformance",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalKpisDownlinePerformanceDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerEmailsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/emails",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersEmailsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerEmailOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/emails",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersEmailDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerEmailOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/emails/{emailAddress}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.emailAddress
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerEmailsMetadataOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/emails/metadata",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataEmailMetadataDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createEndConsumerOrderOperationSpec = {
    httpMethod: "POST",
    path: "endConsumerOrders",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalEndConsumerOrdersEndConsumerOrderDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        default: {}
    },
    serializer: serializer
};
var getEndConsumerOrdersOperationSpec = {
    httpMethod: "GET",
    path: "endConsumerOrders",
    queryParameters: [
        Parameters.customerId1
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalEndConsumerOrdersEndConsumerOrdersDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerEndConsumersOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/endConsumers",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersEndConsumersDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerEndConsumerOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/endConsumers",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersEndConsumerDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerEndConsumerOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/endConsumers/{endConsumerId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.endConsumerId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersEndConsumerDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateCustomerEndConsumerOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/endConsumers/{endConsumerId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.endConsumerId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersEndConsumerDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerEndConsumerOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/endConsumers/{endConsumerId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.endConsumerId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getEndConsumersMetadataOperationSpec = {
    httpMethod: "GET",
    path: "endConsumersMetadata",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataEndConsumerMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var getApplicationsEndCustomerReferralDiscountLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "applications/endCustomerReferralDiscount/localization",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSharedLocalizationDto
        },
        default: {}
    },
    serializer: serializer
};
var createCustomersEndCustomerOperationSpec = {
    httpMethod: "POST",
    path: "customers/endCustomers",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersEndCustomerDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        default: {}
    },
    serializer: serializer
};
var getCustomersEndCustomerMetadataOperationSpec = {
    httpMethod: "GET",
    path: "customers/endCustomerMetadata",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataEndCustomerMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var getSystemEndpointsIdentityServerOperationSpec = {
    httpMethod: "GET",
    path: "system/endpoints/identityServer",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSystemIdentityServerEndpointsDto
        },
        default: {}
    },
    serializer: serializer
};
var getSystemEndpointsOnlineOperationSpec = {
    httpMethod: "GET",
    path: "system/endpoints/online",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSystemOnlineEndpointsDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerExternalAccountsWeChatUnionIdOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/externalAccounts/weChat/unionId",
    urlParameters: [
        Parameters.customerId2
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersWeChatUnionIdDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerExternalProfilesOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/externalProfiles",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalAccountsExternalProfileDto"
                        }
                    }
                }
            }
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerExternalAccountOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/externalAccounts/{externalProvider}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.externalProvider
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerSocialEntityTypeSocialEntityFavoriteOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/socialEntityTypes/{socialEntityType}/socialEntities/{socialEntityId}/favorite",
    urlParameters: [
        Parameters.customerId2,
        Parameters.socialEntityType,
        Parameters.socialEntityId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        400: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerSocialEntityTypeSocialEntityFavoriteOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/socialEntityTypes/{socialEntityType}/socialEntities/{socialEntityId}/favorite",
    urlParameters: [
        Parameters.customerId2,
        Parameters.socialEntityType,
        Parameters.socialEntityId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        400: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerFinancialSetOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/financialSet",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersFinancialSetDto
        },
        default: {}
    },
    serializer: serializer
};
var getApplicationsOriflameAppFrontPageBannersOperationSpec = {
    httpMethod: "GET",
    path: "applications/oriflameApp/frontPageBanners",
    queryParameters: [
        Parameters.thumbnailSize,
        Parameters.thumbnailQuality
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsOriflameAppFrontPageBannersDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsOriflameAppFrontPageBannerOperationSpec = {
    httpMethod: "GET",
    path: "applications/oriflameApp/frontPageBanners/{frontPageBannerId}",
    urlParameters: [
        Parameters.frontPageBannerId
    ],
    queryParameters: [
        Parameters.thumbnailSize,
        Parameters.thumbnailQuality
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsOriflameAppFrontPageBannerDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerGrantedCreditOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/grantedCredit",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersGrantedCreditDto
        },
        default: {}
    },
    serializer: serializer
};
var updateCustomerGrantedCreditOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/grantedCredit",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersGrantedCreditDto
    },
    responses: {
        204: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerGuaranteeCreditOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/guaranteeCredit",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersGuaranteeCreditDto
        },
        default: {}
    },
    serializer: serializer
};
var getApplicationsGuaranteeCreditLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "applications/guaranteeCredit/localization",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSharedLocalizationDto
        },
        default: {}
    },
    serializer: serializer
};
var getApplicationsGuaranteeCreditGrantedCreditConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "applications/guaranteeCredit/grantedCreditConfiguration",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalGuaranteeCreditGrantedCreditConfigurationDto
        },
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionHomeDeliveryOptionsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/homeDeliveryOptions",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingHomeDeliveryOptionsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getSocialMediaLibraryImageInfoOperationSpec = {
    httpMethod: "GET",
    path: "socialMediaLibrary/imageInfos/{imageInfoId}",
    urlParameters: [
        Parameters.imageInfoId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSocialMediaLibraryImageInfoDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getSocialMediaLibraryImageInfosOperationSpec = {
    httpMethod: "GET",
    path: "socialMediaLibrary/imageInfos",
    queryParameters: [
        Parameters.search,
        Parameters.top2,
        Parameters.skip0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSocialMediaLibraryImageInfosDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getInAppNotificationsOperationSpec = {
    httpMethod: "GET",
    path: "inAppNotifications",
    queryParameters: [
        Parameters.since,
        Parameters.take0
    ],
    headerParameters: [
        Parameters.xTenantContext1,
        Parameters.xClientApplication,
        Parameters.acceptLanguage0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalNotificationsInAppNotificationsDto
        },
        default: {}
    },
    serializer: serializer
};
var getInAppNotificationUpdatesOperationSpec = {
    httpMethod: "GET",
    path: "inAppNotificationUpdates",
    queryParameters: [
        Parameters.since,
        Parameters.take0
    ],
    headerParameters: [
        Parameters.xTenantContext1,
        Parameters.xClientApplication,
        Parameters.acceptLanguage0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalNotificationsInAppNotificationsDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerInAppNotificationsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/inAppNotifications",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.since,
        Parameters.take0
    ],
    headerParameters: [
        Parameters.xTenantContext1,
        Parameters.xClientApplication
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalNotificationsInAppNotificationsDto
        },
        403: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerInAppNotificationsOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/inAppNotifications",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.dueDate,
        Parameters.notificationType,
        Parameters.messageType
    ],
    headerParameters: [
        Parameters.xTenantContext1,
        Parameters.xClientApplication
    ],
    responses: {
        200: {},
        204: {},
        400: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerInAppNotificationUpdatesOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/inAppNotificationUpdates",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.since,
        Parameters.take0
    ],
    headerParameters: [
        Parameters.xTenantContext1,
        Parameters.xClientApplication
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalNotificationsInAppNotificationsDto
        },
        403: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerInAppNotificationViewedOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/inAppNotifications/{notificationId}/viewed",
    urlParameters: [
        Parameters.notificationId,
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext1,
        Parameters.xClientApplication
    ],
    responses: {
        200: {},
        204: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerInAppNotificationsViewedOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/inAppNotifications/viewed",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.dueDate,
        Parameters.notificationType,
        Parameters.messageType
    ],
    headerParameters: [
        Parameters.xTenantContext1,
        Parameters.xClientApplication
    ],
    responses: {
        200: {},
        204: {},
        400: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerInAppNotificationOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/inAppNotifications/{notificationId}",
    urlParameters: [
        Parameters.notificationId,
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext1,
        Parameters.xClientApplication
    ],
    responses: {
        200: {},
        204: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getNotificationMessageTypesOperationSpec = {
    httpMethod: "GET",
    path: "notificationMessageTypes",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalNotificationsNotificationMessageTypesDto
        },
        403: {},
        default: {}
    },
    serializer: serializer
};
var getIngredientsOperationSpec = {
    httpMethod: "GET",
    path: "ingredients",
    queryParameters: [
        Parameters.ingredientCodes,
        Parameters.top3,
        Parameters.skip1
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalIngredientLibraryIngredientsDto
        },
        default: {}
    },
    serializer: serializer
};
var getIngredientOperationSpec = {
    httpMethod: "GET",
    path: "ingredients/{ingredientCode}",
    urlParameters: [
        Parameters.ingredientCode
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalIngredientLibraryIngredientDto
        },
        default: {}
    },
    serializer: serializer
};
var getJoiningFeeDialogHtmlOperationSpec = {
    httpMethod: "GET",
    path: "joiningFeeDialog/html",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersJoiningFeeDialogHtmlDto
        },
        default: {}
    },
    serializer: serializer
};
var createCustomerSocialEntityTypeSocialEntityLikeOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/socialEntityTypes/{socialEntityType}/socialEntities/{socialEntityId}/like",
    urlParameters: [
        Parameters.customerId2,
        Parameters.socialEntityType,
        Parameters.socialEntityId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        400: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerSocialEntityTypeSocialEntityLikeOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/socialEntityTypes/{socialEntityType}/socialEntities/{socialEntityId}/like",
    urlParameters: [
        Parameters.customerId2,
        Parameters.socialEntityType,
        Parameters.socialEntityId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        400: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getAddressNodesOperationSpec = {
    httpMethod: "GET",
    path: "addressNodes",
    queryParameters: [
        Parameters.searchText,
        Parameters.types,
        Parameters.country1,
        Parameters.region1,
        Parameters.province1,
        Parameters.district1,
        Parameters.area1,
        Parameters.city1,
        Parameters.locality1,
        Parameters.street1,
        Parameters.zipCode1,
        Parameters.skip2,
        Parameters.top4
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalAddressesLookupAddressNodesDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getAddressNodeOperationSpec = {
    httpMethod: "GET",
    path: "addressNodes/{nodeId}",
    urlParameters: [
        Parameters.nodeId
    ],
    queryParameters: [
        Parameters.country2
    ],
    headerParameters: [
        Parameters.xTenantContext0,
        Parameters.xMockResponse
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalAddressesLookupAddressNodeDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getAddressSuggestionsOperationSpec = {
    httpMethod: "GET",
    path: "addressSuggestions",
    queryParameters: [
        Parameters.searchText,
        Parameters.pathKey,
        Parameters.country1,
        Parameters.top4
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalAddressesLookupAddressSuggestionsDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsMakeupwizardLooksOperationSpec = {
    httpMethod: "GET",
    path: "applications/makeupwizard/looks",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsMakeUpWizardLooksDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsMakeupwizardLooktagsOperationSpec = {
    httpMethod: "GET",
    path: "applications/makeupwizard/looktags",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsMakeUpWizardTagsDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsMakeupwizardLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "applications/makeupwizard/localization",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSharedLocalizationDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsMakeupwizardCategoriesOperationSpec = {
    httpMethod: "GET",
    path: "applications/makeupwizard/categories",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsMakeUpWizardMakeupWizardCategoriesDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsMakeupwizardWelcomeScreenStepsOperationSpec = {
    httpMethod: "GET",
    path: "applications/makeupwizard/welcomeScreenSteps",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsMakeUpWizardWelcomeScreenStepsDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCommissionPlansMatureMarketTitleQualificationsOperationSpec = {
    httpMethod: "GET",
    path: "commissionPlans/matureMarket/titleQualifications",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCommissionPlansTitleQualificationsMmDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerNameBankContactsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/nameBankContacts",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.top4,
        Parameters.skip2
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalMobileOfficeNameBankNameBankContactsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerNameBankContactOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/nameBankContacts",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalMobileOfficeNameBankNameBankContactDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        201: {},
        400: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerNameBankContactOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/nameBankContacts/{contactId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.contactId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalMobileOfficeNameBankNameBankContactDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateCustomerNameBankContactOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/nameBankContacts/{contactId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.contactId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalMobileOfficeNameBankNameBankContactDto
    },
    responses: {
        204: {},
        400: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerNameBankContactOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/nameBankContacts/{contactId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.contactId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsNavigationNavigationOperationSpec = {
    httpMethod: "GET",
    path: "applications/navigation/navigations/{navigationType}",
    urlParameters: [
        Parameters.navigationType
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalNavigationNavigationCollectionDto
        },
        default: {}
    },
    serializer: serializer
};
var getApplicationsNavigationCustomerNavigationOperationSpec = {
    httpMethod: "GET",
    path: "applications/navigation/customers/{customerId}/navigations/{navigationType}",
    urlParameters: [
        Parameters.customerId2,
        Parameters.navigationType
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalNavigationNavigationCollectionDto
        },
        default: {}
    },
    serializer: serializer
};
var getNavigationTagOperationSpec = {
    httpMethod: "GET",
    path: "navigationTags/{relatedCategory}",
    urlParameters: [
        Parameters.relatedCategory
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalNavigationNavigationTagsCollectionDto
        },
        default: {}
    },
    serializer: serializer
};
var createCustomerNewsTopOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/news/top",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalSharedPagingDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCmsArticleTeasersDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var createRelayNotificationsMobileOperationSpec = {
    httpMethod: "POST",
    path: "relayNotifications/mobile",
    headerParameters: [
        Parameters.xTenantContext1
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalNotificationsMobileNotificationDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "String"
                }
            }
        },
        204: {},
        400: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerNotificationOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/notifications",
    urlParameters: [
        Parameters.customerId2
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalNotificationsCustomerNotificationDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalNotificationsCustomerNotificationDto
        },
        400: {},
        403: {},
        409: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerNotificationOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/notifications/{notificationId}",
    urlParameters: [
        Parameters.customerId2,
        Parameters.notificationId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        403: {},
        409: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerNotificationOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/notifications/{notificationId}",
    urlParameters: [
        Parameters.customerId2,
        Parameters.notificationId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalNotificationsCustomerNotificationDto
        },
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerNotificationSendOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/notifications/{notificationId}/send",
    urlParameters: [
        Parameters.customerId2,
        Parameters.notificationId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        400: {},
        403: {},
        404: {},
        409: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerNotificationRecallOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/notifications/{notificationId}/recall",
    urlParameters: [
        Parameters.customerId2,
        Parameters.notificationId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        403: {},
        409: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerNotificationsSearchOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/notifications/search",
    urlParameters: [
        Parameters.customerId2
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalNotificationsCustomerNotificationSearchRequestDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalNotificationsCustomerNotificationSearchResultDto
        },
        204: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCustomersNotificationsTargetsOperationSpec = {
    httpMethod: "GET",
    path: "customers/notifications/targets",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalNotificationsTargetCollectionDto
        },
        403: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionOfferChoicesOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/offers/{offerId}/choices",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingOfferChoicesDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionOfferChoicesOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/offers/{offerId}/choices",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionOfferChoiceOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/offers/{offerId}/choices/{itemCode}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId0,
        Parameters.itemCode0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingOfferChoiceDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateShoppingSessionOfferChoiceOperationSpec = {
    httpMethod: "PUT",
    path: "shoppingSessions/{sessionId}/offers/{offerId}/choices/{itemCode}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId0,
        Parameters.itemCode0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingOfferChoiceDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingOfferChoiceDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionOfferChoiceOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/offers/{offerId}/choices/{itemCode}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId0,
        Parameters.itemCode0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionOfferOfferItemsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/offers/{offerId}/offerItems",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId0
    ],
    queryParameters: [
        Parameters.skip0,
        Parameters.top1
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingOfferItemsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionOffersOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/offers",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingOffersDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerOnboardingTestOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/onboardingTest",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersOnboardingTestDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateCustomerOnboardingTestOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/onboardingTest",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersOnboardingTestDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getTestsSmallSizeResponseOnlineOperationSpec = {
    httpMethod: "GET",
    path: "tests/smallSizeResponse/online",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalTestsOnlineTestDataSetsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTestsMediumSizeResponseOnlineOperationSpec = {
    httpMethod: "GET",
    path: "tests/mediumSizeResponse/online",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalTestsOnlineTestDataSetsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTestsBigSizeResponseOnlineOperationSpec = {
    httpMethod: "GET",
    path: "tests/bigSizeResponse/online",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalTestsOnlineTestDataSetsDto
        },
        default: {}
    },
    serializer: serializer
};
var createShoppingSessionOrderOperationSpec = {
    httpMethod: "POST",
    path: "shoppingSessions/{sessionId}/order",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingOrderDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getOrdersOperationSpec = {
    httpMethod: "GET",
    path: "orders",
    queryParameters: [
        Parameters.customerId1,
        Parameters.unpaidOnly
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalShoppingOrderDto"
                        }
                    }
                }
            }
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getOrderOperationSpec = {
    httpMethod: "GET",
    path: "orders/{orderId}",
    urlParameters: [
        Parameters.orderId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingOrderDto
        },
        default: {}
    },
    serializer: serializer
};
var deleteOrderOperationSpec = {
    httpMethod: "DELETE",
    path: "orders/{orderId}",
    urlParameters: [
        Parameters.orderId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        400: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerOrdersLastUnpaidOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/orders/lastUnpaid",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.orderOriginType
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingUnpaidOrderDto
        },
        default: {}
    },
    serializer: serializer
};
var getOrderRealtimeOrderTrackingOperationSpec = {
    httpMethod: "GET",
    path: "orders/{orderId}/realtimeOrderTracking",
    urlParameters: [
        Parameters.orderId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingOrderTrackingsDto
        },
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionPaymentMethodsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/paymentMethods",
    urlParameters: [
        Parameters.sessionId
    ],
    queryParameters: [
        Parameters.isBlocked
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingPaymentMethodsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionPaymentProvidersOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/paymentProviders",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingPaymentProvidersDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionPaymentProviderOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/paymentProviders/{paymentProviderId}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.paymentProviderId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingPaymentProvidersDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getPaymentProviderOperationSpec = {
    httpMethod: "GET",
    path: "paymentProviders/{paymentProviderId}",
    urlParameters: [
        Parameters.paymentProviderId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingPaymentProviderDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionPaymentOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/payment",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingPaymentDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateShoppingSessionPaymentOperationSpec = {
    httpMethod: "PUT",
    path: "shoppingSessions/{sessionId}/payment",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingPaymentDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingPaymentDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getPeriodOperationSpec = {
    httpMethod: "GET",
    path: "periods/{periodCode}",
    urlParameters: [
        Parameters.periodCode
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalBonusesPeriodDto
        },
        401: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getPeriodsOperationSpec = {
    httpMethod: "GET",
    path: "periods",
    queryParameters: [
        Parameters.offsets
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalBonusesPeriodDto"
                        }
                    }
                }
            }
        },
        400: {},
        401: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getPeriodsCurrentPeriodOperationSpec = {
    httpMethod: "GET",
    path: "periods/currentPeriod",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalBonusesCurrentPeriodDto
        },
        401: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getConceptsPermissionsOperationSpec = {
    httpMethod: "POST",
    path: "concepts/permissions",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalConceptsPermissionsQueryDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsPermissionsDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getConceptPermissionOperationSpec = {
    httpMethod: "GET",
    path: "concepts/{conceptCode}/permission",
    urlParameters: [
        Parameters.conceptCode
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsPermissionDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerConceptsPermissionsOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/concepts/permissions",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalConceptsPermissionsQueryDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsPermissionsDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerConceptPermissionOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/concepts/{conceptCode}/permission",
    urlParameters: [
        Parameters.customerId0,
        Parameters.conceptCode
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsPermissionDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getProductsPermissionsOperationSpec = {
    httpMethod: "POST",
    path: "products/permissions",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalProductsPermissionsQueryDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsPermissionsDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getProductPermissionOperationSpec = {
    httpMethod: "GET",
    path: "products/{productCode}/permission",
    urlParameters: [
        Parameters.productCode
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsPermissionDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerProductPermissionOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/products/{productCode}/permission",
    urlParameters: [
        Parameters.customerId0,
        Parameters.productCode
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsPermissionDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerProductsPermissionsOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/products/permissions",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalProductsPermissionsQueryDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsPermissionsDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerRolesPermissionsOperationSpec = {
    httpMethod: "GET",
    path: "customer/{customerId}/roles/permissions",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Sequence",
                    element: {
                        type: {
                            name: "Composite",
                            className: "GlobalCustomersPermissionDto"
                        }
                    }
                }
            }
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerPersonalBeautyStoreOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/personalBeautyStore",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersPersonalBeautyStoreDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerPersonalBeautyStoreOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/personalBeautyStore",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersPersonalBeautyStoreDto
    },
    responses: {
        200: {},
        201: {},
        400: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateCustomerPersonalBeautyStoreOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/personalBeautyStore",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersPersonalBeautyStoreDto
    },
    responses: {
        201: {},
        204: {},
        400: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerPersonalBeautyStoreMetadataOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/personalBeautyStore/metadata",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataPbsMetadataDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsPersonalMenuLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "applications/personalMenu/localization",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSharedLocalizationDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsPersonalMenuOperationSpec = {
    httpMethod: "GET",
    path: "applications/personalMenu",
    queryParameters: [
        Parameters.rootLevelOnly,
        Parameters.orderType,
        Parameters.userHash
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsPersonalMenuPersonalMenuDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerPersonalPerformanceOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/personalPerformance",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalKpisPersonalPerformanceDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerPersonalProductsListOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/personalProductsList/{listId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.listId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersPersonalProductsListDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateCustomerPersonalProductsListOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/personalProductsList/{listId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.listId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersPersonalProductsListDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersPersonalProductsListDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerPersonalProductsListOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/personalProductsList/{listId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.listId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerPersonalProductsListsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/personalProductsLists",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersPersonalProductsListsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerPersonalProductsListOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/personalProductsList",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersPersonalProductsListDto
    },
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsPersonalProductsListLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "applications/personalProductsList/localization",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSharedLocalizationDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsPersonalProductsListConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "applications/personalProductsList/configuration",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsPersonalProductsListConfigurationDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerPhonesOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/phones",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersPhonesDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerPhoneOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/phones",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersPhoneDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateCustomerPhoneOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/phones/{telephoneId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.telephoneId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersPhoneDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerPhoneOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/phones/{telephoneId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.telephoneId1
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerPhonesMetadataOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/phones/metadata",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataTelephoneMetadataDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerPhoneVerificationRequestOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/phones/{telephoneId}/verificationRequest",
    urlParameters: [
        Parameters.customerId0,
        Parameters.telephoneId1
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersTelephoneVerificationRequestDto
        },
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateCustomerPhoneVerificationRequestOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/phones/{telephoneId}/verificationRequest",
    urlParameters: [
        Parameters.customerId0,
        Parameters.telephoneId1
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersTelephoneVerificationRequestDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getPopularProductsOperationSpec = {
    httpMethod: "GET",
    path: "popularProducts",
    queryParameters: [
        Parameters.type0,
        Parameters.categoryId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalPopularProductsProductCollectionDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerPreferencesOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/preferences",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersCustomerPreferencesDto
        },
        default: {}
    },
    serializer: serializer
};
var updateCustomerPreferencesOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/preferences",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersCustomerPreferencesDto
    },
    responses: {
        204: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerPreferencesMetadataOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/preferencesMetadata",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataCustomerPreferencesMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var getConceptsPricesOperationSpec = {
    httpMethod: "POST",
    path: "concepts/prices",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalConceptsConceptPricesQueryDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsConceptPricesDto
        },
        400: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getConceptPriceOperationSpec = {
    httpMethod: "GET",
    path: "concepts/{conceptCode}/price",
    urlParameters: [
        Parameters.conceptCode
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsConceptPriceDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerConceptsPricesOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/concepts/prices",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalConceptsConceptPricesQueryDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsConceptPricesDto
        },
        400: {},
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerConceptPriceOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/concepts/{conceptCode}/price",
    urlParameters: [
        Parameters.customerId0,
        Parameters.conceptCode
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConceptsConsultantConceptPriceDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getProductsPricesOperationSpec = {
    httpMethod: "POST",
    path: "products/prices",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalProductsProductPricesQueryDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsProductPricesDto
        },
        400: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerProductPriceOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/products/{productCode}/price",
    urlParameters: [
        Parameters.customerId0,
        Parameters.productCode
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsConsultantProductPriceDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerProductsPricesOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/products/prices",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalProductsProductPricesQueryDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsProductPricesDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getProductBundleOperationSpec = {
    httpMethod: "GET",
    path: "productBundles/{productCode}",
    urlParameters: [
        Parameters.productCode
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsProductBundleDto
        },
        default: {}
    },
    serializer: serializer
};
var getProductBundlesOperationSpec = {
    httpMethod: "GET",
    path: "productBundles",
    queryParameters: [
        Parameters.includedProducts,
        Parameters.productCodes0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsProductBundlesDto
        },
        default: {}
    },
    serializer: serializer
};
var getProductLabelsContentOperationSpec = {
    httpMethod: "GET",
    path: "productLabelsContent",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsProductLabelsContentCollectionDto
        },
        default: {}
    },
    serializer: serializer
};
var getProductListTypeProductListOperationSpec = {
    httpMethod: "GET",
    path: "productListTypes/{productListType}/productLists/{productListId}",
    urlParameters: [
        Parameters.productListType,
        Parameters.productListId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSharedProductListDto
        },
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerProductListTypeProductListsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/productListTypes/{productListType}/productLists",
    urlParameters: [
        Parameters.customerId0,
        Parameters.productListType
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersProductListsDto
        },
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerProductListTypeProductListOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/productListTypes/{productListType}/productLists",
    urlParameters: [
        Parameters.customerId0,
        Parameters.productListType
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalSharedProductListDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSharedProductListDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerProductListTypeProductListOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/productListTypes/{productListType}/productLists/{productListId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.productListType,
        Parameters.productListId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSharedProductListDto
        },
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateCustomerProductListTypeProductListOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/productListTypes/{productListType}/productLists/{productListId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.productListType,
        Parameters.productListId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalSharedProductListDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSharedProductListDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteCustomerProductListTypeProductListOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/productListTypes/{productListType}/productLists/{productListId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.productListType,
        Parameters.productListId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsProductListingListingOperationSpec = {
    httpMethod: "GET",
    path: "applications/productListing/listings/{productListingPageId}",
    urlParameters: [
        Parameters.productListingPageId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsProductListingDto
        },
        default: {}
    },
    serializer: serializer
};
var getApplicationsProductListingPromoBannersOperationSpec = {
    httpMethod: "GET",
    path: "applications/productListing/promoBanners",
    queryParameters: [
        Parameters.ids
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsProductListingPromoBannersDto
        },
        default: {}
    },
    serializer: serializer
};
var getProductsOperationSpec = {
    httpMethod: "POST",
    path: "products",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalProductsQueryDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsProductsDto
        },
        default: {}
    },
    serializer: serializer
};
var getProductOperationSpec = {
    httpMethod: "GET",
    path: "products/{productCode}",
    urlParameters: [
        Parameters.productCode
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsProductDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getProductsLabelsOperationSpec = {
    httpMethod: "GET",
    path: "productsLabels",
    queryParameters: [
        Parameters.productCodes1
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsProductsLabelsDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerProfileOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/profile",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersProfileDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateCustomerProfileOperationSpec = {
    httpMethod: "PUT",
    path: "customers/{customerId}/profile",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersProfileDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerProfileMetadataOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/profile/metadata",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersMetadataProfileMetadataDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsProfileLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "applications/profile/localization",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSharedLocalizationDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerApplicationsProfileConfigurationsSectionsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/applications/profile/configurations/sections",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsProfileSectionsConfigurationDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsProfileConfigurationExternalProfilesOperationSpec = {
    httpMethod: "GET",
    path: "applications/profile/configuration/externalProfiles",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsProfileExternalProfilesMetadataDto
        },
        default: {}
    },
    serializer: serializer
};
var getPromotionOperationSpec = {
    httpMethod: "GET",
    path: "promotions/{promotionId}",
    urlParameters: [
        Parameters.promotionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalPromotionsPromotionDto
        },
        default: {}
    },
    serializer: serializer
};
var getPromotionsOperationSpec = {
    httpMethod: "GET",
    path: "promotions",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalPromotionsPromotionsDto
        },
        default: {}
    },
    serializer: serializer
};
var createPushNotificationsInstallationOperationSpec = {
    httpMethod: "POST",
    path: "pushNotifications/installations",
    headerParameters: [
        Parameters.xTenantContext1,
        Parameters.acceptLanguage0,
        Parameters.xClientApplication
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalNotificationsInstallationRequestDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "String"
                }
            }
        },
        default: {}
    },
    serializer: serializer
};
var createCustomerPushNotificationsInstallationOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/pushNotifications/installations",
    urlParameters: [
        Parameters.customerId2
    ],
    headerParameters: [
        Parameters.xTenantContext1,
        Parameters.acceptLanguage1,
        Parameters.xClientApplication
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalNotificationsInstallationRequestDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "String"
                }
            }
        },
        default: {}
    },
    serializer: serializer
};
var deleteCustomerPushNotificationsInstallationOperationSpec = {
    httpMethod: "DELETE",
    path: "customers/{customerId}/pushNotifications/installations/{installationId}",
    urlParameters: [
        Parameters.customerId2,
        Parameters.installationId
    ],
    headerParameters: [
        Parameters.xTenantContext1,
        Parameters.xClientApplication
    ],
    responses: {
        200: {},
        204: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createPushNotificationsRegistrationOperationSpec = {
    httpMethod: "POST",
    path: "pushNotifications/registrations",
    headerParameters: [
        Parameters.xTenantContext0,
        Parameters.xNotificationCentreApiKey
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalNotificationsPushRegistrationDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "String"
                }
            }
        },
        default: {}
    },
    serializer: serializer
};
var deletePushNotificationsApplicationRegistrationIdOperationSpec = {
    httpMethod: "DELETE",
    path: "pushNotifications/applications/{applicationKey}/registrationId/{registrationId}",
    urlParameters: [
        Parameters.applicationKey,
        Parameters.registrationId
    ],
    headerParameters: [
        Parameters.xTenantContext0,
        Parameters.xNotificationCentreApiKey
    ],
    responses: {
        200: {},
        204: {},
        default: {}
    },
    serializer: serializer
};
var deletePushNotificationsApplicationDeviceTokenOperationSpec = {
    httpMethod: "DELETE",
    path: "pushNotifications/applications/{applicationKey}/deviceToken/{deviceToken}",
    urlParameters: [
        Parameters.applicationKey,
        Parameters.deviceToken
    ],
    headerParameters: [
        Parameters.xTenantContext0,
        Parameters.xNotificationCentreApiKey
    ],
    responses: {
        200: {},
        204: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsRealTimeOrderTrackingLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "applications/realTimeOrderTracking/localization",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSharedLocalizationDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerRecurringPaymentCardsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/recurringPaymentCards",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.onlyActive
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersRecurringPaymentCardsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionReferralOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/referral",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingReferralDto
        },
        402: {},
        default: {}
    },
    serializer: serializer
};
var createShoppingSessionReferralOperationSpec = {
    httpMethod: "POST",
    path: "shoppingSessions/{sessionId}/referral",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingReferralDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingReferralDto
        },
        400: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerConsultantOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/consultants",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersConsultantRegistrationDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersRegistrationResultDto
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createConsultantOperationSpec = {
    httpMethod: "POST",
    path: "consultants",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersSelfRegistrationDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersRegistrationResultDto
        },
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getRegistrationMetadataOperationSpec = {
    httpMethod: "GET",
    path: "registrations/{registrationType}/metadata",
    urlParameters: [
        Parameters.registrationType
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersRegistrationMetadataDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getProductRelationsOperationSpec = {
    httpMethod: "GET",
    path: "products/{productCode}/relations",
    urlParameters: [
        Parameters.productCode
    ],
    queryParameters: [
        Parameters.relationTypes
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalProductsRelationsDto
        },
        default: {}
    },
    serializer: serializer
};
var createReportingReportsInstallOperationSpec = {
    httpMethod: "POST",
    path: "reporting/reports/install",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerRequiredTermsOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/requiredTerms",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.termsType
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersRequiredTermsDto
        },
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionSectionSectionItemsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/sections/{sectionId}/sectionItems",
    urlParameters: [
        Parameters.sessionId,
        Parameters.sectionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSectionItemsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionSectionsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/sections",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSectionsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionSectionSuggestionsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/sectionSuggestions",
    urlParameters: [
        Parameters.sessionId
    ],
    queryParameters: [
        Parameters.code,
        Parameters.top1
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSectionSuggestionsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionSectionWishlistItemsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/sections/{sectionId}/wishlist",
    urlParameters: [
        Parameters.sessionId,
        Parameters.sectionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSectionWishlistDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionSectionWishlistItemsOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/sections/{sectionId}/wishlist",
    urlParameters: [
        Parameters.sessionId,
        Parameters.sectionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createShoppingSessionSectionWishlistOperationSpec = {
    httpMethod: "POST",
    path: "shoppingSessions/{sessionId}/sections/{sectionId}/wishlist",
    urlParameters: [
        Parameters.sessionId,
        Parameters.sectionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingSectionWishlistItemDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSectionWishlistItemDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionSectionWishlistOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/sections/{sectionId}/wishlist/{itemCode}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.sectionId,
        Parameters.itemCode0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSectionWishlistItemDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateShoppingSessionSectionWishlistOperationSpec = {
    httpMethod: "PUT",
    path: "shoppingSessions/{sessionId}/sections/{sectionId}/wishlist/{itemCode}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.sectionId,
        Parameters.itemCode0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingSectionWishlistItemDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSectionWishlistItemDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionSectionWishlistOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/sections/{sectionId}/wishlist/{itemCode}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.sectionId,
        Parameters.itemCode0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsNetworkCommunicationConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "applications/networkCommunication/configuration",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalNetworkCommunicationConfigurationDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsNetworkCommunicationLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "applications/networkCommunication/localization",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSharedLocalizationDto
        },
        401: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionShippingJokerChoiceOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/shippingJokerChoice",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingShippingChoiceDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionShippingJokerChoiceOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/shippingJokerChoice",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createShoppingSessionShippingJokerChoiceOperationSpec = {
    httpMethod: "POST",
    path: "shoppingSessions/{sessionId}/shippingJokerChoice",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingShippingChoiceDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingShippingChoiceDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionShippingJokerChoicesOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/shippingJokerChoices",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingShippingChoicesDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionShippingJokerChoicesOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/shippingJokerChoices",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateShoppingSessionShippingJokerChoicesOperationSpec = {
    httpMethod: "PUT",
    path: "shoppingSessions/{sessionId}/shippingJokerChoices",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingShippingChoicesDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingShippingChoicesDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionShippingJokersOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/shippingJokers",
    urlParameters: [
        Parameters.sessionId
    ],
    queryParameters: [
        Parameters.deliveryChannelId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingShippingJokersDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createShoppingSessionShoppingBagOperationSpec = {
    httpMethod: "POST",
    path: "shoppingSessions/{sessionId}/shoppingBag",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionShoppingBagOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/shoppingBag",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionShoppingBagAggregatedItemsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/shoppingBag/aggregatedItems",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingShoppingBagAggregatedItemsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateShoppingSessionShoppingBagBagItemOperationSpec = {
    httpMethod: "PUT",
    path: "shoppingSessions/{sessionId}/shoppingBag/bagItems/{bagItemId}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.bagItemId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingShoppingBagItemDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionShoppingBagBagItemOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/shoppingBag/bagItems/{bagItemId}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.bagItemId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionShoppingBagBagItemBackorderOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/shoppingBag/bagItems/{bagItemId}/backorder",
    urlParameters: [
        Parameters.sessionId,
        Parameters.bagItemId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createShoppingSessionShoppingBagBagItemBackorderOperationSpec = {
    httpMethod: "POST",
    path: "shoppingSessions/{sessionId}/shoppingBag/bagItems/{bagItemId}/backorder",
    urlParameters: [
        Parameters.sessionId,
        Parameters.bagItemId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionShoppingBagBagItemBackorderOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/shoppingBag/bagItems/{bagItemId}/backorder",
    urlParameters: [
        Parameters.sessionId,
        Parameters.bagItemId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createShoppingSessionShoppingBagBagItemOperationSpec = {
    httpMethod: "POST",
    path: "shoppingSessions/{sessionId}/shoppingBag/bagItems",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingShoppingBagItemDto
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateShoppingSessionShoppingBagBagItemsOperationSpec = {
    httpMethod: "PUT",
    path: "shoppingSessions/{sessionId}/shoppingBag/bagItems",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: {
            serializedName: "body",
            type: {
                name: "Sequence",
                element: {
                    type: {
                        name: "Composite",
                        className: "GlobalShoppingShoppingBagItemDto"
                    }
                }
            }
        }
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateApplicationsWechatpbsShoppingSessionShoppingBagBagItemsOperationSpec = {
    httpMethod: "PUT",
    path: "applications/wechatpbs/shoppingSessions/{sessionId}/shoppingBag/bagItems",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: {
            serializedName: "body",
            type: {
                name: "Sequence",
                element: {
                    type: {
                        name: "Composite",
                        className: "GlobalShoppingShoppingBagItemDto"
                    }
                }
            }
        }
    },
    responses: {
        204: {},
        400: {
            bodyMapper: Mappers.GlobalSharedValidationErrorsResponse
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionMessagesOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/messages",
    urlParameters: [
        Parameters.sessionId
    ],
    queryParameters: [
        Parameters.type1,
        Parameters.top1
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingShoppingMessagesDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createShoppingSessionOperationSpec = {
    httpMethod: "POST",
    path: "shoppingSessions",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingShoppingDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingShoppingSessionDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingShoppingSessionDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerSocialEntityTypeSocialEntitiesOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/socialEntityTypes/{socialEntityType}/socialEntities",
    urlParameters: [
        Parameters.customerId2,
        Parameters.socialEntityType
    ],
    queryParameters: [
        Parameters.socialAction
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSocialMediaLibrarySocialEntitiesDto
        },
        default: {}
    },
    serializer: serializer
};
var getSocialEntityTypeSocialEntitiesStatOperationSpec = {
    httpMethod: "GET",
    path: "socialEntityTypes/{socialEntityType}/socialEntitiesStats/{socialEntityId}",
    urlParameters: [
        Parameters.socialEntityType,
        Parameters.socialEntityId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSocialMediaLibrarySocialEntityDto
        },
        403: {},
        default: {}
    },
    serializer: serializer
};
var getSocialEntityTypeSocialEntitiesStatsOperationSpec = {
    httpMethod: "GET",
    path: "socialEntityTypes/{socialEntityType}/socialEntitiesStats",
    urlParameters: [
        Parameters.socialEntityType
    ],
    queryParameters: [
        Parameters.sortType,
        Parameters.sortBy,
        Parameters.take1,
        Parameters.skip0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalSocialMediaLibrarySocialStatsEntity
        },
        403: {},
        500: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionSpecialOfferOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/specialOffers/{offerId}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSpecialOfferDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionSpecialOfferChoiceOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/specialOffers/{offerId}/choice",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSpecialOfferChoiceDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateShoppingSessionSpecialOfferChoiceOperationSpec = {
    httpMethod: "PUT",
    path: "shoppingSessions/{sessionId}/specialOffers/{offerId}/choice",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingSpecialOfferChoiceDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSpecialOfferChoiceDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionSpecialOfferChoiceOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/specialOffers/{offerId}/choice",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionSpecialOfferReplacementsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/specialOffers/{offerId}/replacements",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSpecialOfferReplacementsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionSpecialOffersOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/specialOffers",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSpecialOffersDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionSpecialOfferVoucherOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/specialOffers/{offerId}/voucher",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSpecialOfferVoucherDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createShoppingSessionSpecialOfferVoucherChoiceOperationSpec = {
    httpMethod: "POST",
    path: "shoppingSessions/{sessionId}/specialOffers/{offerId}/voucher/choices",
    urlParameters: [
        Parameters.sessionId,
        Parameters.offerId1
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingSpecialOfferVoucherChoiceDto
    },
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "Number"
                }
            }
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionSpecialOfferVoucherChoiceOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/specialOffers/{offerId}/voucher/choices/{choiceId}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.choiceId,
        Parameters.offerId1
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerStepsToSuccessTasksOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/stepsToSuccess",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.top4,
        Parameters.skip2
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalMobileOfficeStepsToSuccessStepsToSuccessTasksDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerStepsToSuccessTaskOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/stepsToSuccess/{taskId}",
    urlParameters: [
        Parameters.customerId0,
        Parameters.taskId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalMobileOfficeStepsToSuccessStepsToSuccessTaskDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createCustomerStepsToSuccessCompleteOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/stepsToSuccess/{taskId}/complete",
    urlParameters: [
        Parameters.taskId,
        Parameters.customerId2
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        400: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getCustomerSubscriptionConfigurationOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/subscriptionConfiguration",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersSubscriptionConfigurationDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerSubscriptionAvailabilitiesOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/subscriptionAvailabilities",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.products
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersSubscriptionProductsAvailabilityDto
        },
        default: {}
    },
    serializer: serializer
};
var getCustomerSubscriptionTypesOperationSpec = {
    httpMethod: "GET",
    path: "customers/{customerId}/subscriptionTypes",
    urlParameters: [
        Parameters.customerId0
    ],
    queryParameters: [
        Parameters.product
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersSubscriptionTypesDto
        },
        default: {}
    },
    serializer: serializer
};
var createCustomerSubscriptionInstructionOperationSpec = {
    httpMethod: "POST",
    path: "customers/{customerId}/subscriptionInstructions",
    urlParameters: [
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalCustomersSubscriptionInstructionDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersSubscriptionInstructionDto
        },
        default: {}
    },
    serializer: serializer
};
var getApplicationsSubscriptionWizardLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "applications/subscriptionWizard/localization",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSharedLocalizationDto
        },
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionSummaryOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/summary",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingShoppingSummaryDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionSummaryAccountsOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/summary/accounts",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingSummaryAccountsDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsSupportCenterCategoriesOperationSpec = {
    httpMethod: "GET",
    path: "applications/supportCenter/categories",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSupportCenterSupportCenterCategoriesDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsSupportCenterCategoryOperationSpec = {
    httpMethod: "GET",
    path: "applications/supportCenter/categories/{categoryId}",
    urlParameters: [
        Parameters.categoryId2
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSupportCenterSupportCenterCategoryDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsSupportCenterLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "applications/supportCenter/localization",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSharedLocalizationDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsSupportCenterFeaturedFaqsOperationSpec = {
    httpMethod: "GET",
    path: "applications/supportCenter/featuredFaqs",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSupportCenterSupportCenterFeaturedFaqsDto
        },
        default: {}
    },
    serializer: serializer
};
var getApplicationsSupportCenterSearchOperationSpec = {
    httpMethod: "GET",
    path: "applications/supportCenter/search",
    queryParameters: [
        Parameters.query,
        Parameters.skip0,
        Parameters.take2
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSupportCenterSupportCenterSearchResultDto
        },
        401: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var getProductsTagGroupsOperationSpec = {
    httpMethod: "GET",
    path: "products/tagGroups",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalTagsTagGroupsDto
        },
        default: {}
    },
    serializer: serializer
};
var getTermHtmlOperationSpec = {
    httpMethod: "GET",
    path: "terms/{termId}/html",
    urlParameters: [
        Parameters.termId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalCustomersTermHtmlDto
        },
        default: {}
    },
    serializer: serializer
};
var getTestPingOperationSpec = {
    httpMethod: "GET",
    path: "test/ping",
    responses: {
        200: {
            bodyMapper: {
                serializedName: "parsedResponse",
                type: {
                    name: "String"
                }
            }
        },
        default: {}
    },
    serializer: serializer
};
var getSettingsClientSettingCustomerOperationSpec = {
    httpMethod: "GET",
    path: "settingsClients/{settingsClient}/settings/{settingId}/customers/{customerId}",
    urlParameters: [
        Parameters.settingsClient,
        Parameters.settingId,
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConsultantsSettingDto
        },
        400: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var updateSettingsClientSettingCustomerOperationSpec = {
    httpMethod: "PUT",
    path: "settingsClients/{settingsClient}/settings/{settingId}/customers/{customerId}",
    urlParameters: [
        Parameters.settingsClient,
        Parameters.settingId,
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalConsultantsSettingDto
    },
    responses: {
        200: {
            bodyMapper: Mappers.GlobalConsultantsSettingDto
        },
        400: {},
        403: {},
        default: {}
    },
    serializer: serializer
};
var deleteSettingsClientSettingCustomerOperationSpec = {
    httpMethod: "DELETE",
    path: "settingsClients/{settingsClient}/settings/{settingId}/customers/{customerId}",
    urlParameters: [
        Parameters.settingsClient,
        Parameters.settingId,
        Parameters.customerId0
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        400: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionVoucherCodesOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/voucherCodes",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingVoucherCodesDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionVoucherCodesOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/voucherCodes",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var createShoppingSessionVoucherCodeOperationSpec = {
    httpMethod: "POST",
    path: "shoppingSessions/{sessionId}/voucherCodes",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalShoppingVoucherCodeDto
    },
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionVoucherCodeOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/voucherCodes/{voucherCode}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.voucherCode
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingVoucherCodeDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var deleteShoppingSessionVoucherCodeOperationSpec = {
    httpMethod: "DELETE",
    path: "shoppingSessions/{sessionId}/voucherCodes/{voucherCode}",
    urlParameters: [
        Parameters.sessionId,
        Parameters.voucherCode
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        204: {},
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getVouchersOperationSpec = {
    httpMethod: "GET",
    path: "vouchers",
    queryParameters: [
        Parameters.customerId1
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingVouchersDto
        },
        default: {}
    },
    serializer: serializer
};
var getShoppingSessionVouchersOperationSpec = {
    httpMethod: "GET",
    path: "shoppingSessions/{sessionId}/vouchers",
    urlParameters: [
        Parameters.sessionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalShoppingVouchersDto
        },
        401: {},
        403: {},
        404: {},
        default: {}
    },
    serializer: serializer
};
var getApplicationsVouchersLocalizationOperationSpec = {
    httpMethod: "GET",
    path: "applications/vouchers/localization",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalApplicationsSharedLocalizationDto
        },
        default: {}
    },
    serializer: serializer
};
var createLoginProvidersWeChatExternalAccountOperationSpec = {
    httpMethod: "POST",
    path: "login/providers/weChat/externalAccount",
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalLoginWeChatAccountDto
    },
    responses: {
        204: {},
        400: {},
        401: {},
        default: {}
    },
    serializer: serializer
};
var getLoginProvidersWeChatExternalAccountPlatformsOperationSpec = {
    httpMethod: "GET",
    path: "login/providers/weChat/externalAccount/{unionId}/platforms",
    urlParameters: [
        Parameters.unionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GlobalLoginProvidersWeChatPlatformsDto
        },
        default: {}
    },
    serializer: serializer
};
var createLoginProvidersWeChatExternalAccountPlatformOperationSpec = {
    httpMethod: "POST",
    path: "login/providers/weChat/externalAccount/{unionId}/platforms",
    urlParameters: [
        Parameters.unionId
    ],
    headerParameters: [
        Parameters.xTenantContext0
    ],
    requestBody: {
        parameterPath: [
            "options",
            "body"
        ],
        mapper: Mappers.GlobalLoginProvidersWeChatPlatformDto
    },
    responses: {
        204: {},
        default: {}
    },
    serializer: serializer
};
export { Api, ApiContext, Models as ApiModels, Mappers as ApiMappers };

//# sourceMappingURL=api.js.map
